/** Extra Oro MX page copy. Merged after chrome dictionaries. */
export const oroMxPageI18n: Record<string, Record<string, string>> = {
  'es-MX': {
    'oro.common.back': 'Volver',
    'oro.common.close': 'Cerrar',
    'oro.common.confirm': 'Confirmar',
    'oro.common.add': 'Agregar',
    'oro.common.save': 'Guardar',
    'oro.common.saving': 'Guardando…',
    'oro.common.next': 'Siguiente',
    'oro.common.prev': 'Anterior',
    'oro.common.complete': 'Completar',
    'oro.common.details': 'Detalles',
    'oro.common.empty': '¡Ups! Aún no hay datos.',
    'oro.common.noData': 'Sin datos',
    'oro.common.search': 'Buscar',
    'oro.common.copy': 'Copiar',
    'oro.common.guest': 'Invitado',
    'oro.common.none': 'Nulo',
    'oro.common.now': 'Ahora',
    'oro.common.rules': 'Reglas',
    'oro.home.seeAll': 'Ver todo',
    'oro.home.loadMore': 'Cargar más',
    'oro.home.hours24': '24 horas',
    'oro.home.bigPrizes': 'Grandes premios',
    'oro.home.jackpot': 'Bono jackpot:',
    'oro.search.title': 'Buscar juegos',
    'oro.search.placeholder': 'Buscar nombre del juego',
    'oro.search.minChars': 'Ingresa al menos 2 caracteres',
    'oro.search.recommended': 'Juegos recomendados',
    'oro.push.text': 'Activa las notificaciones push para recibir actualizaciones de promociones, depósitos y más',
    'oro.push.subscribe': 'Suscribirse',
    'oro.fd.title': 'Tu bono de primer depósito está por vencer',
    'oro.fd.remain': 'Tiempo restante',
    'oro.fd.go': 'Ir a depositar',
    'oro.deposit.guest': 'Estás en modo de invitado. Vincula tu cuenta ahora para evitar perder tu saldo y progreso si cambias de dispositivo o borras la app.',
    'oro.deposit.completeProfile': 'Completar Perfil',
    'oro.deposit.tab': 'Depositar',
    'oro.deposit.withdrawTab': 'Retirar',
    'oro.deposit.channel': 'Canal de depósito',
    'oro.deposit.firstReward': 'Recompensa por primer depósito',
    'oro.deposit.cash': 'Efectivo',
    'oro.deposit.reward': 'Recompensa',
    'oro.deposit.points': 'Puntos',
    'oro.deposit.total': 'Total',
    'oro.deposit.optOut': 'No participar en esta promoción',
    'oro.deposit.cta': 'Depositar {amount} MXN',
    'oro.deposit.infoTitle': 'Consulta promociones elegibles antes de depositar.',
    'oro.deposit.infoDesc': 'Contacta soporte si tienes dudas.',
    'oro.deposit.how': 'Cómo depositar',
    'oro.deposit.noAccount': 'No se detectó cuenta',
    'oro.deposit.addWithdraw': 'Agregar cuenta de retiro',
    'oro.deposit.balance': 'Saldo',
    'oro.deposit.withdrawable': 'Saldo retirable',
    'oro.deposit.withdrawAmount': 'Monto de retiro',
    'oro.deposit.withdrawPh': 'Ingresa el monto de retiro',
    'oro.deposit.safe': 'Acceso seguro proporcionado por Orocasino oficial y terceros de confianza.',
    'oro.deposit.safeContact': 'Si tienes dudas, contacta a nuestro',
    'oro.deposit.liveSupport': 'Soporte en vivo',
    'oro.deposit.tip.0': 'Después de completar tu depósito, participa en actividades y gana recompensas. ¡Actúa ya!',
    'oro.deposit.tip.1': 'Asegúrate de que el monto del depósito coincida con el pago. Cualquier diferencia puede retrasar o fallar la recarga.',
    'oro.deposit.tip.2': 'El monto mínimo por depósito y retiro es 50.00 MXN. Para más información, consulta nuestros términos y condiciones.',
    'oro.wallet.title': 'Gestión de tarjetas',
    'oro.wallet.addAccount': 'Agregar cuenta',
    'oro.wallet.addBank': 'Agregar tarjeta bancaria',
    'oro.wallet.addUsdt': 'Agregar dirección de billetera USDT',
    'oro.wallet.addPix': 'Agregar PIX',
    'oro.wallet.addEwallet': 'Agregar monedero electrónico',
    'oro.wallet.accountName': 'Nombre de cuenta',
    'oro.wallet.bankName': 'Nombre del banco',
    'oro.wallet.bankAccount': 'Cuenta bancaria',
    'oro.wallet.walletName': 'Nombre de billetera',
    'oro.wallet.currency': 'Moneda',
    'oro.wallet.chain': 'Blockchain',
    'oro.wallet.walletAddr': 'Dirección de monedero',
    'oro.wallet.notes': 'Notas',
    'oro.wallet.noteExchange': 'Agrega tu propia billetera de exchange.',
    'oro.wallet.usdtOnly': 'Solo se admiten direcciones USDT {chain}.',
    'oro.wallet.usdtPh': 'Ingresa la dirección USDT {chain}',
    'oro.wallet.holder': 'Nombre del titular',
    'oro.wallet.pixType': 'Tipo de clave',
    'oro.wallet.pixKey': 'Clave',
    'oro.wallet.ewalletNo': 'Número de monedero',
    'oro.wallet.contactSupport': 'Por favor contacta a soporte',
    'oro.wallet.ph.account': 'Ingresa el nombre de cuenta',
    'oro.wallet.ph.bank': 'Ingresa el nombre del banco',
    'oro.wallet.ph.bankAcc': 'Ingresa la cuenta bancaria',
    'oro.wallet.ph.wallet': 'Ingresa el nombre de la billetera',
    'oro.wallet.ph.holder': 'Ingresa el nombre del titular',
    'oro.wallet.ph.ewallet': 'Ingresa el número de monedero',
    'oro.wallet.err.account': 'Ingresa el nombre de cuenta',
    'oro.wallet.err.bank': 'Ingresa el nombre del banco',
    'oro.wallet.err.bankAcc': 'Ingresa la cuenta bancaria',
    'oro.wallet.err.holder': 'Ingresa el nombre del titular',
    'oro.wallet.err.ewallet': 'Ingresa el número de monedero',
    'oro.wallet.err.addr': 'Ingresa la dirección de recepción',
    'oro.wallet.err.trcStart': 'La dirección TRC-20 debe comenzar con T',
    'oro.wallet.err.trcLen': 'La dirección TRC-20 debe tener 34 caracteres',
    'oro.wallet.err.addrStart': 'La dirección {chain} debe comenzar con {prefix}',
    'oro.wallet.err.addrLen': 'La dirección {chain} debe tener {n} caracteres',
    'oro.wallet.err.walletName': 'Ingresa el nombre de la billetera',
    'oro.wallet.err.chain': 'Seleccionar cadena',
    'oro.wallet.err.pixKey': 'Ingresa la clave',
    'oro.wallet.err.required': '{field} es obligatorio',
    'oro.wallet.err.digits': '{field} debe tener {n} dígitos',
    'oro.wallet.err.invalid': '{field} no es válido',
    'oro.wallet.err.binMismatch': '{field} no coincide con el banco seleccionado',
    'oro.wallet.binHint': 'El número debe pertenecer al banco seleccionado',
    'oro.wallet.delete': 'Eliminar',
    'oro.wallet.deleted': 'Cuenta eliminada',
    'oro.wallet.empty': 'Sin cuentas',
    'oro.wallet.saved': 'Guardado',
    'oro.wallet.tab.bank_card': 'Tarjeta bancaria',
    'oro.wallet.tab.usdt': 'USDT',
    'oro.wallet.tab.e_wallet': 'Monedero electrónico',
    'oro.wallet.tab.pix': 'PIX',
    'oro.edit.title': 'Editar perfil',
    'oro.edit.avatar': 'Avatar del usuario',
    'oro.edit.realName': 'Nombre real',
    'oro.edit.realNamePh': 'Ingresa tu nombre real',
    'oro.edit.loginName': 'Cuenta de acceso',
    'oro.edit.loginNamePh': 'Ingresa tu cuenta de acceso',
    'oro.edit.loginReadonly': 'La cuenta registrada no se puede cambiar.',
    'oro.edit.password': 'Contraseña de acceso',
    'oro.edit.passwordPh': '6-16 caracteres',
    'oro.edit.hint': 'Evita caracteres especiales o tu cuenta podría no ser compatible.',
    'oro.edit.birthday': 'Fecha de nacimiento',
    'oro.edit.datePh': 'DD / MM / AAAA',
    'oro.edit.phone': 'Número de teléfono',
    'oro.edit.codePh': 'Ingresa el código de verificación',
    'oro.edit.email': 'Correo electrónico',
    'oro.edit.errAccount': 'La cuenta debe tener 3-64 letras, números o . _ @ -',
    'oro.edit.errPassword': 'La contraseña debe tener 6-16 caracteres.',
    'oro.edit.errRealName': 'El nombre real debe tener entre 2 y 96 caracteres.',
    'oro.edit.errPhone': 'Ingresa un teléfono mexicano de 10 dígitos.',
    'oro.edit.errEmail': 'Ingresa un correo válido.',
    'oro.edit.errBirthday': 'Debes tener al menos 18 años.',
    'oro.edit.errTaken': 'Esta cuenta ya está en uso.',
    'oro.edit.errPhoneTaken': 'Este teléfono ya está en uso.',
    'oro.edit.errEmailTaken': 'Este correo ya está en uso.',
    'oro.sec.title': 'Configuración de seguridad',
    'oro.sec.low': 'Bajo',
    'oro.sec.pwdTitle': 'Configura tu contraseña de acceso.',
    'oro.sec.pwdDesc': 'Cambia tu contraseña con regularidad para mantenerla segura y única.',
    'oro.sec.mailTitle': 'Verificación de correo',
    'oro.sec.mailDesc': 'Verifica tu correo para mejorar la seguridad de tu cuenta.',
    'oro.sec.sessions': 'Número de sesiones',
    'oro.sec.device': 'Dispositivo',
    'oro.sec.action': 'Acción',
    'oro.rec.tx': 'Transacciones',
    'oro.rec.bets': 'Historial de apuestas',
    'oro.rec.moves': 'Movimientos',
    'oro.rec.biz.ACTIVITY_REWARD': 'Recompensa de actividad',
    'oro.rec.biz.DEPOSIT': 'Depósito',
    'oro.rec.biz.DEPOSIT_REBATE': 'Reembolso de depósito',
    'oro.rec.biz.GAME_REBATE': 'Reembolso de juego',
    'oro.rec.biz.GAME_SPIN': 'Apuesta',
    'oro.rec.biz.GIFT_BONUS': 'Bono de regalo',
    'oro.rec.biz.MANUAL_CREDIT': 'Ajuste crédito',
    'oro.rec.biz.MANUAL_DEBIT': 'Ajuste débito',
    'oro.rec.biz.REDEEM_CODE': 'Código de canje',
    'oro.rec.biz.REFERRAL_BONUS': 'Bono de referido',
    'oro.rec.biz.TASK_REWARD': 'Recompensa de tarea',
    'oro.rec.biz.VIP_BONUS': 'Bono VIP',
    'oro.rec.biz.WHEEL_BONUS': 'Bono de ruleta',
    'oro.rec.biz.WITHDRAW': 'Retiro',
    'oro.rec.biz.WITHDRAW_HOLD': 'Retiro congelado',
    'oro.rec.biz.WITHDRAW_REFUND': 'Retiro reembolsado',
    'oro.rec.biz.WITHDRAW_UNHOLD': 'Retiro descongelado',
    'oro.rec.biz.WUFU_BONUS': 'Bono Wufu',
    'oro.filter.today': 'Hoy',
    'oro.filter.three_days': '3 días',
    'oro.filter.seven_days': '7 días',
    'oro.filter.half_month': '15 días',
    'oro.filter.one_month': '30 días',
    'oro.filter.yesterday': 'Ayer',
    'oro.filter.month': 'Este mes',
    'oro.filter.deposit': 'Depósito',
    'oro.filter.withdraw': 'Retiro',
    'oro.filter.all': 'Todo',
    'oro.filter.allLevels': 'Todos',
    'oro.filter.level.1': 'Nivel 1',
    'oro.filter.level.2': 'Nivel 2',
    'oro.filter.level.3': 'Nivel 3',
    'oro.notice.title': 'Notificaciones',
    'oro.notice.empty': 'Sin mensajes',
    'oro.notice.platform': 'Plataforma',
    'oro.notice.personal': 'Personal',
    'oro.reward.title': 'Detalle de recompensas',
    'oro.reward.conditions': 'Condiciones de recompensa',
    'oro.reward.tx': 'Transacción',
    'oro.reward.allBonus': 'Todos los bonos',
    'oro.reward.type': 'Tipo de recompensa',
    'oro.reward.amount': 'Monto de la recompensa',
    'oro.reward.time': 'Hora',
    'oro.reward.footnote': 'Mostrando datos de los últimos 90 días',
    'oro.reward.claim.0': 'Bono de regalo',
    'oro.reward.claim.1': 'Bono de nivel',
    'oro.reward.claim.2': 'Ofertas de eventos',
    'oro.reward.claim.3': 'Recompensa de misión',
    'oro.reward.claim.4': 'Ruleta gratis',
    'oro.reward.claim.5': 'Cinco bendiciones',
    'oro.reward.claim.6': 'Recompensas de referido',
    'oro.reward.claim.7': 'Código de reclamo',
    'oro.reward.claim.8': 'Reembolso por depósito',
    'oro.reward.claim.9': 'Reembolso de juego',
    'oro.disc.claimed': 'Bonus Claimed',
    'oro.disc.redeem': 'Código de canje',
    'oro.disc.empty': 'Sin datos',
    'oro.disc.ph': 'Ingresa el código de canje',
    'oro.disc.fail': 'No se pudo canjear el código',
    'oro.disc.ok': 'Canje exitoso. +{amount}',
    'oro.disc.claimOk': 'Recompensa reclamada. +{amount}',
    'oro.disc.claimFail': 'No se pudo reclamar la recompensa',
    'oro.disc.err.REDEEM_ALREADY_CLAIMED': 'Este código ya fue canjeado',
    'oro.disc.err.REDEEM_CODE_EXHAUSTED': 'Este código ya no está disponible',
    'oro.disc.err.REDEEM_CODE_EXPIRED': 'Este código ha expirado',
    'oro.disc.err.REDEEM_CODE_INVALID': 'Código inválido',
    'oro.disc.err.REDEEM_IP_LIMITED': 'Demasiados intentos. Inténtalo más tarde',
    'oro.disc.tab.permanent': 'Mis bonos',
    'oro.disc.tab.permanent-alt': 'permanentes',
    'oro.disc.tab.vip': 'Bonos VIP',
    'oro.disc.tab.prizes': 'Mis premios',
    'oro.disc.vip.level': 'Nivel VIP actual',
    'oro.disc.vip.weekLoss': 'Pérdida de la semana',
    'oro.disc.vip.monthBet': 'Apuestas del mes',
    'oro.disc.vip.todayLoss': 'Pérdida de ayer',
    'oro.disc.vip.yesterdayBet': 'Apuestas de ayer',
    'oro.disc.vip.reward': 'Premio',
    'oro.disc.vip.nextReward': 'Próximo bono',
    'oro.disc.vip.granted': 'Ya acreditado',
    'oro.disc.vip.autoHint': 'Se acredita automáticamente al cumplir las condiciones.',
    'oro.disc.vip.manualHint': 'Reclama manualmente al cumplir las condiciones.',
    'oro.disc.standing.scratch': 'Raspadito',
    'oro.disc.standing.wheel': 'Ruleta',
    'oro.disc.standing.jackpot': 'Jackpot',
    'oro.disc.standing.rescue': '¡RECUPERA',
    'oro.disc.standing.times': 'Veces disponibles',
    'oro.jackpot.title': 'Jackpot',
    'oro.jackpot.todayReward': 'Recompensa de hoy',
    'oro.jackpot.withdrawable': 'Retirable',
    'oro.jackpot.spinsLeft': 'Oportunidades',
    'oro.jackpot.bonus': 'Estrellas',
    'oro.jackpot.taskBetBtn': 'Apostar',
    'oro.jackpot.taskDepositBtn': 'Depositar',
    'oro.jackpot.pending': 'Pendiente para mañana {amount}',
    'oro.jackpot.claim': 'Reclamar',
    'oro.jackpot.claimOk': 'Reclamado {amount}',
    'oro.jackpot.draw': 'Girar',
    'oro.jackpot.chances': 'Oportunidades: {n}',
    'oro.jackpot.confirmDraw': '¿Usar {amount} estrellas para un giro?',
    'oro.jackpot.insufficient': 'Estrellas insuficientes',
    'oro.jackpot.noChances': 'Sin oportunidades hoy',
    'oro.jackpot.unavailable': 'Jackpot no disponible por ahora',
    'oro.jackpot.complete': '¡Completaste un premio!',
    'oro.jackpot.tasks': 'Gana giros',
    'oro.jackpot.spinOne': 'giro',
    'oro.jackpot.spinMany': 'giros',
    'oro.jackpot.task.login': 'Inicio diario VIP · {n} {unit}',
    'oro.jackpot.task.bet': 'Apuesta {amount} en tragamonedas · {n} {unit}',
    'oro.jackpot.task.deposit': 'Deposita {amount} · {n} {unit}',
    'oro.jackpot.taskGo': 'Ir',
    'oro.jackpot.taskDone': 'Hecho',
    'oro.jackpot.rulesTitle': 'Cómo jugar',
    'oro.jackpot.rulesCost': 'Cada giro gasta 1 oportunidad y 20 estrellas. Las estrellas no se pueden retirar.',
    'oro.jackpot.rulesCollect': 'Completa MINI, MINOR, MAJOR o GRAND para ganar un premio en efectivo aleatorio dentro del rango.',
    'oro.jackpot.rulesReset': 'A las 00:00 de cada día se restablecerán las letras obtenidas y el número de sorteos.',
    'oro.jackpot.rulesClaim': 'El efectivo se puede reclamar el mismo día. Puedes reclamarlo aunque el evento se detenga.',
    'oro.jackpot.rulesPoints': 'Las oportunidades diarias dependen de tu VIP. Las tareas de apuesta y depósito se cuentan en la zona horaria del sitio.',
    'oro.scratch.title': 'Raspadito',
    'oro.scratch.introBefore': 'Junta',
    'oro.scratch.introAfter': 'cartas iguales para canjear el premio.',
    'oro.scratch.cards': 'Tus tarjetas',
    'oro.scratch.chances': '{n} raspaditos',
    'oro.scratch.getAttempts': 'Obtener intentos',
    'oro.scratch.thanks': 'Gracias',
    'oro.scratch.noTickets': 'Completa tareas para obtener más raspaditos.',
    'oro.scratch.unavailable': 'El raspadito no está disponible por ahora.',
    'oro.scratch.redeem': 'Canjear',
    'oro.scratch.redeemWild': 'Canjear comodín',
    'oro.scratch.taskTitle': 'Tareas diarias',
    'oro.scratch.currentTickets': 'Intentos actuales: {n}',
    'oro.scratch.cantidad': 'Cantidad {n}',
    'oro.scratch.goComplete': 'Ir',
    'oro.scratch.noData': 'Sin tareas',
    'oro.scratch.congrats': '¡Felicidades!',
    'oro.scratch.confirm': 'Confirmar',
    'oro.scratch.rulesH2': 'Reglas',
    'oro.scratch.rulesH3': 'Raspadito',
    'oro.scratch.rulesPlay': 'Cómo jugar',
    'oro.scratch.rulesCover': 'Raspa la cubierta para revelar una carta.',
    'oro.scratch.rulesCollect': 'Junta un set completo para canjear el premio en efectivo.',
    'oro.scratch.rulesWithdraw': 'El premio en efectivo requiere el múltiplo de apuesta configurado.',
    'oro.scratch.rulesFair': 'Cada raspadito se sortea en el servidor. El resultado no se puede cambiar al raspar.',
    'oro.scratch.rulesJackpot': 'Premio mayor',
    'oro.scratch.rulesRestrict': 'Una cuenta por persona, IP o dispositivo.',
    'oro.scratch.rulesUse': 'Solo aplica a los juegos permitidos por la promoción.',
    'oro.scratch.rulesTags': 'Tragamonedas',
    'oro.scratch.rulesOther': 'La plataforma puede verificar y descalificar conducta fraudulenta.',
    'oro.scratch.rulesAbuse': 'El abuso, las cuentas múltiples y las apuestas de cobertura están prohibidos.',
    'oro.scratch.rulesFinal': 'La interpretación final corresponde a Orocasino.',
    'oro.scratch.rulesLuck': 'Juega con responsabilidad. Prohibido para menores de 18 años.',
    'oro.disc.available.claim': 'Reclamar recompensa',
    'oro.disc.available.goScratch': 'Ir a raspar',
    'oro.disc.available.goWheel': 'Ir a la ruleta',
    'oro.disc.available.goUse': 'Usar',
    'oro.disc.available.coupon': 'Bono de depósito',
    'oro.disc.available.qty': 'Cantidad',
    'oro.disc.available.reward': 'Recompensa',
    'oro.disc.available.percent': 'Bono',
    'oro.disc.available.cash': 'Bono',
    'oro.tut.step1': 'Paso 1',
    'oro.tut.step2': 'Paso 2',
    'oro.tut.step3': 'Paso 3',
    'oro.tut.step1.title': '1. Abre el sitio en Safari.',
    'oro.tut.step2.title': '2. Abre el sitio en Safari.',
    'oro.tut.step3.title': '3. Agregar a la pantalla de inicio.',
    'oro.tut.step1.desc': 'Abre Safari en tu teléfono.',
    'oro.tut.step2.desc': 'Abre Safari en tu teléfono.',
    'oro.tut.step3.desc': 'Toca "Agregar a pantalla de inicio".',
    'oro.game.unavailable': 'No se puede entrar al juego por ahora. Inténtalo más tarde.',
    'oro.game.notFound': 'Este juego no está disponible.',
    'oro.game.balanceTooLow': 'Saldo disponible inferior a 1. Recarga antes de jugar.',
    'oro.game.home': 'Volver al inicio',
    'oro.promo.details': 'Detalles',
    'oro.promo.loading': 'Cargando…',
    'oro.promo.loadError': 'No se pudo cargar',
    'oro.promo.retry': 'Reintentar',
    'oro.promo.claiming': 'Reclamando…',
    'oro.promo.claim': 'Reclamar {amount}',
    'oro.promo.claimed': 'Ya reclamado',
    'oro.promo.locked': 'Aún no disponible',
    'oro.promo.login': 'Inicia sesión para reclamar',
    'oro.promo.autoGrantHint': 'Se acredita automáticamente.',
    'oro.promo.empty': 'Sin actividades',
    'oro.promo.cta': 'Participar ahora',
    'oro.promo.app.title': 'DESCARGA LA APP Y RECIBE HASTA',
    'oro.promo.vip.title': 'SUBE A VIP',
    'oro.promo.cashback.title': 'Cashback Semanal VIP',
    'oro.promo.monthly.title': 'INGRESOS MENSUALES VIP',
    'oro.promo.daily.title': '1% DE DIARIO PÉRDIDAS',
    'oro.promo.rescue.title': '¡RECUPERA',
    'oro.promo.rescue.yesterdayLoss': 'Pérdida de ayer',
    'oro.promo.rescue.claimCost': 'Reclamar consume puntos',
    'oro.promo.rescue.needMin': 'No alcanzas el mínimo. Necesitas {amount} para reclamar.',
    'oro.promo.rescue.needMinPlain': 'No alcanzas el mínimo para reclamar.',
    'oro.promo.rescue.canClaim': 'Puedes reclamar {amount}',
    'oro.promo.rescue.claimedHint': 'Ya reclamado hoy.',
    'oro.promo.rescue.loginHint': 'Inicia sesión para ver la pérdida de ayer.',
    'oro.promo.inviteChest.title': 'Recompensas del Cofre del Tesoro',
    'oro.promo.inviteChest.valid': 'Referidos válidos',
    'oro.promo.inviteChest.next': 'Siguiente cofre: {n}',
    'oro.promo.inviteChest.complete': 'Ya reclamaste todos los cofres',
    'oro.promo.inviteChest.ready': '{n} cofres listos para reclamar',
    'oro.promo.inviteChest.tapClaim': 'Reclamar',
    'oro.promo.inviteChest.claimed': 'Reclamado',
    'oro.sign.hero': 'Tareas de registro de 7 días para recién llegados',
    'oro.sign.sub': 'Recompensas diarias',
    'oro.sign.tab.seven': 'Tareas de registro de 7 días para recién llegados',
    'oro.sign.tab.daily': 'Tareas',
    'oro.sign.section.seven': 'Tareas de registro de 7 días para recién llegados',
    'oro.sign.section.daily': 'Tareas diarias',
    'oro.sign.day': 'Día {n}',
    'oro.sign.done': 'Completado',
    'oro.sign.pending': 'Tarea pendiente de reclamar',
    'oro.sign.notStarted': 'Actividad no iniciada',
    'oro.sign.expired': 'Caducado',
    'oro.sign.chest.unlockHint': 'Los cofres Bonus se desbloquean el día 8 desde el registro.',
    'oro.sign.chest.progress': 'Gana {need} más para obtener {reward}',
    'oro.sign.chest.progressMax': 'Recompensa máx alcanzada',
    'oro.sign.chest.accessRewards': 'Recompensas de acceso',
    'oro.sign.chest.open': 'Abrir',
    'oro.sign.chest.open10': 'Abrir 10',
    'oro.sign.chest.checkIn': 'Firmar',
    'oro.sign.chest.checkInWait': 'Firmar ({n}s)',
    'oro.sign.chest.signedToday': 'Ya has firmado hoy',
    'oro.sign.chest.signOk': 'Registro exitoso',
    'oro.sign.chest.unavailable': 'No disponible',
    'oro.sign.chest.claimed': 'Reclamado',
    'oro.sign.chest.rewardTitle': '¡Felicidades!',
    'oro.sign.chest.claim': 'Reclamar',
    'oro.sign.chest.goDeposit': 'Depositar',
    'oro.sign.chest.goInvite': 'Invitar',
    'oro.sign.chest.goBet': 'Apuesta',
    'oro.sign.chest.resignTitle': 'Firmar de nuevo',
    'oro.sign.chest.resignBody': '¿Usar {price} puntos para recuperar el Día {n}?',
    'oro.sign.chest.bonusLabel': 'Puntos: {amount}',
    'oro.sign.chest.openedTitle': '¡Cofre abierto!',
    'oro.sign.chest.openedTotal': 'Total: +{amount}',
    'oro.sign.chest.accept': 'Aceptar',
    'oro.sign.chest.insufficient': 'Puntos insuficientes',
    'oro.sign.chest.toastBonus': '+{amount}',
    'oro.sign.chest.toastResign': '+ Cofre del Día {n}',
    'oro.sign.chest.task.bet_first': 'Apuesta ${n}',
    'oro.sign.chest.task.bet_first_vip': 'Apuesta ${n}',
    'oro.sign.chest.task.deposit_first': 'Depósito ${n}',
    'oro.sign.chest.task.invite_deposit': 'Primer depósito del amigo invitado',
    'oro.sign.tab.chest': 'Cofres Bonus',
    'oro.sign.invite.cta': 'Invitar',
    'oro.sign.invite.summary': 'Invitaste {n} amigos y puedes ganar {amount}',
    'oro.sign.reward.coupon': 'Cupón +{p}%',
    'oro.sign.reward.scratch': 'Raspadito',
    'oro.sign.reward.wheel': 'Giro de ruleta',
    'oro.sign.claimSuccess': 'Recompensa reclamada',
    'oro.sign.rewardIssued': 'Recompensa ya acreditada',
    'oro.sign.rewardReceived': 'Recompensa recibida',
    'oro.sign.claim': 'Reclamar recompensa',
    'oro.sign.goBet': 'Ir a apostar',
    'oro.sign.invite': 'Invita a tus amigos',
    'oro.sign.validBet': 'Apuesta válida',
    'oro.sign.d1.name': 'Día 1 - Inicia sesión para registrarte',
    'oro.sign.d2.name': 'Día 2 - Inicia sesión para registrarte',
    'oro.sign.d3.name': 'Día 3 - Apuesta 10 para registrarte',
    'oro.sign.d4.name': 'Día 4 - Apuesta 20 para registrarte',
    'oro.sign.d5.name': 'Día 5 - Apuesta 30 para registrarte',
    'oro.sign.d6.name': 'Día 6 - Apuesta 50 para registrarte',
    'oro.sign.d7.name': 'Día 7 - Apuesta 100 para registrarte',
    'oro.sign.invite.name': 'Invita a 1 usuario válido',
    'oro.sign.bet100.name': 'Apostar 100 en tragamonedas',
    'oro.sign.bet1000.name': 'Apostar 1000 en tragamonedas',
    'oro.sign.bet5000.name': 'Apostar 5000 en tragamonedas',
    'oro.vip.benefits': 'Nivel VIP y beneficios',
    'oro.vip.about': 'Acerca de Orocasino',
    'oro.vip.tab.upgrade': 'Bono por subir de nivel VIP',
    'oro.vip.tab.daily': 'Reembolso diario',
    'oro.vip.tab.monthly': 'Bono mensual fijo',
    'oro.vip.tab.weekly': 'Reembolso semanal',
    'oro.vip.tab.jackpot': 'Jackpot',
    'oro.vip.col.vip': 'VIP',
    'oro.vip.col.levelBonus': 'Bono de nivel',
    'oro.vip.col.jackpotSpins': 'Giros diarios',
    'oro.vip.col.rebatePct': '% de reembolso',
    'oro.vip.col.maxPrize': 'Premio máx',
    'oro.vip.col.validBets': 'Apuestas válidas',
    'oro.vip.col.fixedBonus': 'Bono fijo',
    'oro.vip.reward.recompensas.title': 'Recompensas',
    'oro.vip.reward.diario.title': 'Bono diario',
    'oro.vip.reward.ayuda.title': 'Ayuda',
    'oro.vip.reward.mensual.title': 'Bono mensual',
    'oro.vip.reward.semanal.title': 'Bono semanal',
    'oro.vip.reward.soporte.title': 'Soporte VIP',
    'oro.vip.reward.cumple.title': 'Cumpleaños',
    'oro.vip.reward.exclusivos.title': 'Exclusivos',
    'oro.vip.reward.fisicos.title': 'Regalos físicos',
    'oro.vip.reward.fisicos.lock': 'Desbloqueado',
    'oro.vip.reward.jackpot.title': 'Jackpot',
    'oro.vip.reward.jackpot.desc': 'Cada día recibes giros de Jackpot según tu nivel VIP. Cuanto más alto el nivel, más oportunidades.',
    'oro.vip.reward.recompensas.desc': 'Cada vez que alcances un nuevo nivel VIP, podrás reclamar las recompensas correspondientes. Cuanto mayor sea el nivel, mayores serán las recompensas, lo que hará que tu camino de crecimiento esté repleto de satisfacciones.',
    'oro.vip.reward.diario.desc': 'Los miembros pueden recibir bonos de apuestas adicionales según el monto de sus apuestas diarias. Cuanto más apuestes, mayores serán las recompensas, lo que hará que tu participación diaria sea más valiosa.',
    'oro.vip.reward.ayuda.desc': 'Cuando experimentes fluctuaciones a corto plazo, podrás recibir fondos de rescate VIP exclusivos que te ayudarán a mantener una experiencia estable y a disfrutar plenamente del juego.',
    'oro.vip.reward.mensual.desc': 'Según tu nivel de membresía y actividad mensual, puedes recibir una generosa bonificación mensual. Gracias por tu continuo apoyo y compañía.',
    'oro.vip.reward.semanal.desc': 'Gana bonificaciones semanales manteniéndote activo, haciendo que cada semana esté llena de sorpresas y emoción.',
    'oro.vip.reward.soporte.desc': 'Los miembros Premium disfrutarán de servicios exclusivos de gestión VIP, que incluyen respuesta rápida, procesamiento prioritario y asistencia personalizada para garantizar que sus necesidades se satisfagan con prontitud.',
    'oro.vip.reward.cumple.desc': 'Durante el mes de tu cumpleaños, te enviaremos nuestros más sinceros deseos y un regalo especial para celebrar este importante momento contigo.',
    'oro.vip.reward.exclusivos.desc': 'Los miembros VIP pueden participar en actividades exclusivas, recibir descuentos limitados, bonos especiales y beneficios exclusivos de la plataforma, y disfrutar de una experiencia única y distinguida.',
    'oro.vip.reward.fisicos.desc': 'Al alcanzar un nivel VIP determinado, tendrá la oportunidad de recibir recompensas físicas como productos digitales de alta gama, regalos de lujo y experiencias de viaje, que pondrán de manifiesto su estatus distinguido.',
    'oro.vip.faq.0.q': '¿Qué es el Club VIP de Orocasino?',
    'oro.vip.faq.0.a': 'Supera tus expectativas y ten una experiencia exclusiva convirtiéndote en cliente VIP.',
    'oro.vip.faq.1.q': '¿Cuáles son los beneficios de unirse al Club VIP?',
    'oro.vip.faq.1.a': 'El Club VIP de Orocasino desbloquea beneficios: información de primera mano, bonificaciones, mayor reembolso, eventos VIP y un gerente personal.',
    'oro.vip.faq.2.q': 'Me gustaría unirme al Club VIP, pero aún no cumplo con los requisitos del nivel. ¿Qué debo hacer?',
    'oro.vip.faq.2.a': 'Mantente activo diariamente, juega tus juegos favoritos, invita amigos y recarga tu cuenta con frecuencia.',
    'oro.vip.faq.3.q': 'Soy miembro y aún no he recibido ninguna bonificación. ¿Por qué?',
    'oro.vip.faq.3.a': 'La bonificación VIP semanal se distribuye cada 7 días. La mensual cada 30 días, si cumples los requisitos.',
    'oro.vip.faq.4.q': '¿Cómo hacerse miembro del Club VIP?',
    'oro.vip.faq.4.a': 'Una vez que tu depósito y monto de apuesta alcancen los estándares, te convertirás en el VIP correspondiente.',
    'oro.vip.faq.5.q': '¿Qué afectará al bono semanal/mensual?',
    'oro.vip.faq.5.a': 'Lo único que afecta tus ganancias es tu actividad de juego. La excepción es la bonificación de cumpleaños.',
    'oro.vip.faq.6.q': '¿Hay alguna oferta especial para los miembros del Club VIP?',
    'oro.vip.faq.6.a': 'Sí, hay muchos. Tu gerente te contará todo lo demás en detalle.',
    'oro.team.title': 'Centro de equipo',
    'oro.team.info': 'Información del equipo',
    'oro.team.validFriends': 'Total de amigos válidos',
    'oro.team.todayBets': 'Monto total apostado hoy',
    'oro.team.forecast': 'Según los datos en tiempo real de hoy, los resultados previstos de la próxima evaluación de calificación son los siguientes：{status}',
    'oro.team.rankTip': 'La clasificación de los equipos se actualiza diariamente a medianoche en función de los datos del día anterior; los datos de progreso se basan en los datos en tiempo real de hoy.',
    'oro.team.rewardLv0': 'Recompensa nivel 0',
    'oro.team.rewardLv': 'Recompensa nivel {level}',
    'oro.team.nivel': 'Nivel {level}',
    'oro.team.rewardText': 'Obtén hasta un 5% de reembolso por recarga',
    'oro.team.refLink': 'Enlace de referido',
    'oro.team.invite': 'Invitar amigos',
    'oro.team.distributed': 'Bono distribuido',
    'oro.team.sentTotal': 'Total enviado hasta ahora',
    'oro.team.commission': 'Comisión',
    'oro.team.faq': 'Preguntas frecuentes',
    'oro.team.paidToday': 'Bono pagado hoy MXN0.00',
    'oro.team.refDeposit': 'Bono por depósito de referidos',
    'oro.team.delay': 'Las recompensas pueden retrasarse',
    'oro.team.claimNow': 'Reclamar ahora',
    'oro.team.rebateLog': 'Registro de recompensas de reembolso',
    'oro.team.refBonus': 'Bono de recomendación',
    'oro.team.inviteLead': 'Invita a un amigo a participar.',
    'oro.team.friendGot': 'Tu amigo recibió',
    'oro.team.inviteProgress': 'Progreso de invitaciones de hoy：0/999',
    'oro.team.depositBonus': 'Monto del depósito / Bono',
    'oro.team.depositAmt': 'Monto de depósito',
    'oro.team.anyDeposit': 'Cualquier depósito',
    'oro.team.friendDepositPercentDesc': 'Cuando tu amigo haga un depósito, recibirás el mismo porcentaje sobre cualquier monto.',
    'oro.team.bonus': 'Bono',
    'oro.team.howPromo': '¿Cómo obtener bonos de promoción?',
    'oro.team.whatPlan': '¿Qué es el plan de dividendos del equipo?',
    'oro.team.howEarn': '¿Cómo ganar bonos de promoción?',
    'oro.team.lv': 'Nivel de equipo',
    'oro.team.members': 'Miembros del equipo',
    'oro.team.volume': 'Volumen del equipo (apuestas)',
    'oro.team.notes': 'Notas / Reglas:',
    'oro.team.calc': 'Calculadora de comisión',
    'oro.team.calcRate': 'Tasa de comisión: 10%',
    'oro.team.calcLabel': 'Ingresa el volumen válido',
    'oro.team.calcPh': 'Tasa de comisión (%)',
    'oro.team.settleTitle': 'Liquidación y retiro de comisiones',
    'oro.team.settleAmt': 'Comisión liquidada acumulada',
    'oro.team.settle1': 'Liquidación: diaria a las 00:00 (UTC+8)',
    'oro.team.settle2': 'Retiro: a tarjeta/billetera en 24 horas',
    'oro.team.settle3': 'Retiro mínimo: 0.00',
    'oro.team.settle4': 'Requisito: verificación de identidad',
    'oro.team.refSub': 'Invita a tus amigos a unirse y gana bonos.',
    'oro.team.copied': 'Enlace copiado',
    'oro.team.tab.dashboard': 'Panel de control',
    'oro.team.tab.bonus': 'Mi Bono',
    'oro.team.tab.referral': 'Bono de recomendación',
    'oro.team.tab.rules': 'Reglas',
    'oro.team.stat.invite': 'Invitar amigos',
    'oro.team.stat.valid': 'Amigos válidos',
    'oro.team.stat.today-invite': 'Invitaciones de hoy',
    'oro.team.stat.today-valid': 'Válidos hoy',
    'oro.team.stat.today-deposit': 'Depósitos de hoy',
    'oro.team.stat.today-volume': 'Volumen de hoy',
    'oro.team.bonus.register': 'Bono de registro recomendado de hoy',
    'oro.team.bonus.cashback': 'Reembolso de apuestas',
    'oro.team.bonus.bet-bonus': 'Bono de reembolso de apuestas',
    'oro.team.step.1.title': 'Comparte con amigos',
    'oro.team.step.1.desc': 'Comparte tu enlace de referido, código de referido o código QR con tus amigos.',
    'oro.team.step.2.title': 'Amigos se registran y depositan',
    'oro.team.step.2.desc': 'Invita a tus amigos a registrarse en la plataforma y completar su primer depósito.',
    'oro.team.step.3.title': 'Gana hasta $99,999',
    'oro.team.step.3.desc': 'Cuando tus amigos apuesten y depositen, ganas generosas comisiones.',
    'oro.team.faq.0.q': '¿Qué es el programa de afiliados de Orocasino?',
    'oro.team.faq.0.a': 'Invita amigos a registrarse y jugar para ganar comisiones y recompensas.',
    'oro.team.faq.1.q': '¿Cuánto cuesta participar?',
    'oro.team.faq.1.a': 'Participar en el programa de afiliados es totalmente gratis.',
    'oro.team.faq.2.q': '¿Cuánto he ganado?',
    'oro.team.faq.2.a': 'Puedes consultar tus ganancias acumuladas en el panel de control y en "Mis bonos".',
    'oro.team.faq.3.q': '¿Más amigos o seguidores significan mejores beneficios?',
    'oro.team.faq.3.a': 'Cuantos más amigos válidos invites, mayor será tu nivel de recompensa.',
    'oro.share.title': 'Compartir',
    'oro.share.player': 'Jugador {name}',
    'oro.share.inviteCode': 'Código de invitación {code}',
    'oro.share.save': 'Guardar imagen',
    'oro.share.link': 'Enlace de referido:',
    'oro.share.codeLabel': 'Código de invitación:',
    'oro.share.copied': 'Copiado correctamente',
    'oro.share.copyFail': 'Error al copiar',
    'oro.share.saved': 'Guardado correctamente',
    'oro.share.saveFail': 'Error al guardar',
    'oro.share.history': 'Historial',
    'oro.share.received': 'Recibido',
    'oro.share.sent': 'Distribuido',
    'oro.share.depositFriends': 'Amigos que depositan',
    'oro.share.recentInvite': 'Amigos invitados recientemente',
    'oro.share.recentDeposit': 'Amigos que depositaron recientemente',
    'oro.hist.type.received': 'Registro de recompensas de reembolso',
    'oro.hist.type.retired': 'Registro de reembolsos del equipo',
    'oro.lottery.silver': 'RULETA DIARIA',
    'oro.lottery.gold': 'RULETA DIARIA',
    'oro.lottery.diamond': 'MX RULETA DIARIA',
    'oro.lottery.unlock': '{vip} Desbloquear',
    'oro.lottery.times': 'veces',
    'oro.lottery.thanks': 'Gracias',
    'oro.lottery.recent': 'Ganadores recientes de la ruleta',
    'oro.lottery.pending': 'Pendiente',
    'oro.lottery.needVip': 'Se requiere VIP {level} o superior',
    'oro.lottery.upgrade': 'Mejorar nivel VIP ➔',
    'oro.lottery.rulesBody': 'Gira la ruleta para obtener premios. Las ruletas de nivel superior se desbloquean con VIP.',
    'oro.lottery.noTickets': 'No tienes giros.',
    'oro.lottery.unavailable': 'La ruleta no está disponible por ahora.',
    'oro.lottery.congrats': '¡Felicidades!',
    'oro.team.inviteEarn': 'Invita a tus amigos y gana recompensas.',
    'oro.team.historyLink': 'Historial >',
    'oro.team.friendDepositDesc': 'Cuando tu amigo haga un depósito, recibirás un bono según el monto depositado.',
    'oro.team.refDepositNote': 'Cuando tu referido vuelva a realizar un depósito, recibirás la recompensa correspondiente según el nivel de tu equipo.',
    'oro.team.stepNote': 'Nota: las ganancias de agente no tienen tope — tu esfuerzo trae grandes recompensas.',
    'oro.team.planBody': 'Como agente reclutas subagentes que forman tu equipo. Mayor rendimiento del equipo, mayores dividendos.',
    'oro.team.levelNote': 'Los bonos de reembolso y depósito varían según el nivel de tu equipo del día. Miembros del equipo: cantidad de usuarios válidos que tienes actualmente. Apuestas del equipo (volumen): monto total apostado por tus miembros de línea descendente en un día.',
    'oro.team.calcRun': 'Calcular',
    'oro.team.calcResult': 'Recompensa estimada',
    'oro.edit.getCode': 'Obtener código de verificación',
  },
  'en-US': {
    'oro.common.back': 'Back',
    'oro.common.close': 'Close',
    'oro.common.confirm': 'Confirm',
    'oro.common.add': 'Add',
    'oro.common.save': 'Save',
    'oro.common.saving': 'Saving…',
    'oro.common.next': 'Next',
    'oro.common.prev': 'Previous',
    'oro.common.complete': 'Done',
    'oro.common.details': 'Details',
    'oro.common.empty': 'No data yet.',
    'oro.common.noData': 'No data',
    'oro.common.search': 'Search',
    'oro.common.copy': 'Copy',
    'oro.common.guest': 'Guest',
    'oro.common.none': 'None',
    'oro.common.now': 'Now',
    'oro.common.rules': 'Rules',
    'oro.home.seeAll': 'See all',
    'oro.home.loadMore': 'Load more',
    'oro.home.hours24': '24 hours',
    'oro.home.bigPrizes': 'Big prizes',
    'oro.home.jackpot': 'Jackpot bonus:',
    'oro.search.title': 'Search games',
    'oro.search.placeholder': 'Search game name',
    'oro.search.minChars': 'Enter at least 2 characters',
    'oro.search.recommended': 'Recommended games',
    'oro.push.text': 'Turn on push notifications for promotions, deposits, and more',
    'oro.push.subscribe': 'Subscribe',
    'oro.fd.title': 'Your first-deposit bonus is about to expire',
    'oro.fd.remain': 'Time left',
    'oro.fd.go': 'Go deposit',
    'oro.deposit.guest': 'You are in guest mode. Link your account now so you do not lose balance or progress if you change devices or delete the app.',
    'oro.deposit.completeProfile': 'Complete profile',
    'oro.deposit.tab': 'Deposit',
    'oro.deposit.withdrawTab': 'Withdraw',
    'oro.deposit.channel': 'Deposit channel',
    'oro.deposit.firstReward': 'First deposit reward',
    'oro.deposit.cash': 'Cash',
    'oro.deposit.reward': 'Reward',
    'oro.deposit.points': 'Points',
    'oro.deposit.total': 'Total',
    'oro.deposit.optOut': 'Do not join this promotion',
    'oro.deposit.cta': 'Deposit {amount} MXN',
    'oro.deposit.infoTitle': 'Check eligible promotions before depositing.',
    'oro.deposit.infoDesc': 'Contact support if you have questions.',
    'oro.deposit.how': 'How to deposit',
    'oro.deposit.noAccount': 'No account found',
    'oro.deposit.addWithdraw': 'Add withdrawal account',
    'oro.deposit.balance': 'Balance',
    'oro.deposit.withdrawable': 'Withdrawable balance',
    'oro.deposit.withdrawAmount': 'Withdrawal amount',
    'oro.deposit.withdrawPh': 'Enter withdrawal amount',
    'oro.deposit.safe': 'Secure access provided by official Orocasino and trusted partners.',
    'oro.deposit.safeContact': 'If you have questions, contact our',
    'oro.deposit.liveSupport': 'Live support',
    'oro.deposit.tip.0': 'After depositing, join activities and earn rewards. Act now!',
    'oro.deposit.tip.1': 'Make sure the deposit amount matches the payment. Any mismatch can delay or fail the top-up.',
    'oro.deposit.tip.2': 'Minimum deposit and withdrawal is 50.00 MXN. See our terms for details.',
    'oro.wallet.title': 'Card management',
    'oro.wallet.addAccount': 'Add account',
    'oro.wallet.addBank': 'Add bank card',
    'oro.wallet.addUsdt': 'Add USDT wallet address',
    'oro.wallet.addPix': 'Add PIX',
    'oro.wallet.addEwallet': 'Add e-wallet',
    'oro.wallet.accountName': 'Account name',
    'oro.wallet.bankName': 'Bank name',
    'oro.wallet.bankAccount': 'Bank account',
    'oro.wallet.walletName': 'Wallet name',
    'oro.wallet.currency': 'Currency',
    'oro.wallet.chain': 'Blockchain',
    'oro.wallet.walletAddr': 'Wallet address',
    'oro.wallet.notes': 'Notes',
    'oro.wallet.noteExchange': 'Add your own exchange wallet.',
    'oro.wallet.usdtOnly': 'Only USDT {chain} addresses are accepted.',
    'oro.wallet.usdtPh': 'Enter USDT {chain} address',
    'oro.wallet.holder': 'Account holder',
    'oro.wallet.pixType': 'Key type',
    'oro.wallet.pixKey': 'Key',
    'oro.wallet.ewalletNo': 'Wallet number',
    'oro.wallet.contactSupport': 'Please contact support',
    'oro.wallet.ph.account': 'Enter account name',
    'oro.wallet.ph.bank': 'Enter bank name',
    'oro.wallet.ph.bankAcc': 'Enter bank account',
    'oro.wallet.ph.wallet': 'Enter wallet name',
    'oro.wallet.ph.holder': 'Enter holder name',
    'oro.wallet.ph.ewallet': 'Enter wallet number',
    'oro.wallet.err.account': 'Enter the account name',
    'oro.wallet.err.bank': 'Enter the bank name',
    'oro.wallet.err.bankAcc': 'Enter the bank account',
    'oro.wallet.err.holder': 'Enter the holder name',
    'oro.wallet.err.ewallet': 'Enter the wallet number',
    'oro.wallet.err.addr': 'Enter the receiving address',
    'oro.wallet.err.trcStart': 'TRC-20 address must start with T',
    'oro.wallet.err.trcLen': 'TRC-20 address must be 34 characters',
    'oro.wallet.err.addrStart': '{chain} address must start with {prefix}',
    'oro.wallet.err.addrLen': '{chain} address must be {n} characters',
    'oro.wallet.err.walletName': 'Enter the wallet name',
    'oro.wallet.err.chain': 'Select chain',
    'oro.wallet.err.pixKey': 'Enter the key',
    'oro.wallet.err.required': '{field} is required',
    'oro.wallet.err.digits': '{field} must be {n} digits',
    'oro.wallet.err.invalid': '{field} is invalid',
    'oro.wallet.err.binMismatch': '{field} does not match the selected bank',
    'oro.wallet.binHint': 'The number must belong to the selected bank',
    'oro.wallet.delete': 'Delete',
    'oro.wallet.deleted': 'Account deleted',
    'oro.wallet.empty': 'No accounts',
    'oro.wallet.saved': 'Saved',
    'oro.wallet.tab.bank_card': 'Bank card',
    'oro.wallet.tab.usdt': 'USDT',
    'oro.wallet.tab.e_wallet': 'E-wallet',
    'oro.wallet.tab.pix': 'PIX',
    'oro.edit.title': 'Edit profile',
    'oro.edit.avatar': 'User avatar',
    'oro.edit.realName': 'Real name',
    'oro.edit.realNamePh': 'Enter your real name',
    'oro.edit.loginName': 'Login account',
    'oro.edit.loginNamePh': 'Enter your login account',
    'oro.edit.loginReadonly': 'A registered account cannot be changed.',
    'oro.edit.password': 'Login password',
    'oro.edit.passwordPh': '6-16 characters',
    'oro.edit.hint': 'Avoid special characters or your account may be incompatible.',
    'oro.edit.birthday': 'Date of birth',
    'oro.edit.datePh': 'DD / MM / YYYY',
    'oro.edit.phone': 'Phone number',
    'oro.edit.codePh': 'Enter verification code',
    'oro.edit.email': 'Email',
    'oro.edit.errAccount': 'Account must be 3-64 letters, numbers, or . _ @ -',
    'oro.edit.errPassword': 'Password must be 6-16 characters.',
    'oro.edit.errRealName': 'Real name must be 2-96 characters.',
    'oro.edit.errPhone': 'Enter a 10-digit Mexican phone number.',
    'oro.edit.errEmail': 'Enter a valid email.',
    'oro.edit.errBirthday': 'You must be at least 18 years old.',
    'oro.edit.errTaken': 'This account is already taken.',
    'oro.edit.errPhoneTaken': 'This phone number is already taken.',
    'oro.edit.errEmailTaken': 'This email is already taken.',
    'oro.sec.title': 'Security settings',
    'oro.sec.low': 'Low',
    'oro.sec.pwdTitle': 'Set your login password.',
    'oro.sec.pwdDesc': 'Change your password regularly to keep it unique and safe.',
    'oro.sec.mailTitle': 'Email verification',
    'oro.sec.mailDesc': 'Verify your email to improve account security.',
    'oro.sec.sessions': 'Sessions',
    'oro.sec.device': 'Device',
    'oro.sec.action': 'Action',
    'oro.rec.tx': 'Transactions',
    'oro.rec.bets': 'Bet history',
    'oro.rec.moves': 'Movements',
    'oro.rec.biz.ACTIVITY_REWARD': 'Activity reward',
    'oro.rec.biz.DEPOSIT': 'Deposit',
    'oro.rec.biz.DEPOSIT_REBATE': 'Deposit rebate',
    'oro.rec.biz.GAME_REBATE': 'Game rebate',
    'oro.rec.biz.GAME_SPIN': 'Bet',
    'oro.rec.biz.GIFT_BONUS': 'Gift bonus',
    'oro.rec.biz.MANUAL_CREDIT': 'Manual credit',
    'oro.rec.biz.MANUAL_DEBIT': 'Manual debit',
    'oro.rec.biz.REDEEM_CODE': 'Redeem code',
    'oro.rec.biz.REFERRAL_BONUS': 'Referral bonus',
    'oro.rec.biz.TASK_REWARD': 'Task reward',
    'oro.rec.biz.VIP_BONUS': 'VIP bonus',
    'oro.rec.biz.WHEEL_BONUS': 'Wheel bonus',
    'oro.rec.biz.WITHDRAW': 'Withdraw',
    'oro.rec.biz.WITHDRAW_HOLD': 'Withdraw hold',
    'oro.rec.biz.WITHDRAW_REFUND': 'Withdraw refund',
    'oro.rec.biz.WITHDRAW_UNHOLD': 'Withdraw unhold',
    'oro.rec.biz.WUFU_BONUS': 'Wufu bonus',
    'oro.filter.today': 'Today',
    'oro.filter.three_days': '3 days',
    'oro.filter.seven_days': '7 days',
    'oro.filter.half_month': '15 days',
    'oro.filter.one_month': '30 days',
    'oro.filter.yesterday': 'Yesterday',
    'oro.filter.month': 'This month',
    'oro.filter.deposit': 'Deposit',
    'oro.filter.withdraw': 'Withdraw',
    'oro.filter.all': 'All',
    'oro.filter.allLevels': 'All',
    'oro.filter.level.1': 'Level 1',
    'oro.filter.level.2': 'Level 2',
    'oro.filter.level.3': 'Level 3',
    'oro.notice.title': 'Notifications',
    'oro.notice.empty': 'No messages',
    'oro.notice.platform': 'Platform',
    'oro.notice.personal': 'Personal',
    'oro.reward.title': 'Reward Details',
    'oro.reward.conditions': 'Reward conditions',
    'oro.reward.tx': 'Transaction',
    'oro.reward.allBonus': 'All bonuses',
    'oro.reward.type': 'Reward type',
    'oro.reward.amount': 'Reward amount',
    'oro.reward.time': 'Time',
    'oro.reward.footnote': 'Showing the last 90 days',
    'oro.reward.claim.0': 'Gift bonus',
    'oro.reward.claim.1': 'Level bonus',
    'oro.reward.claim.2': 'Event offers',
    'oro.reward.claim.3': 'Task reward',
    'oro.reward.claim.4': 'Free wheel',
    'oro.reward.claim.5': 'Five blessings',
    'oro.reward.claim.6': 'Referral rewards',
    'oro.reward.claim.7': 'Redeem code',
    'oro.reward.claim.8': 'Deposit rebate',
    'oro.reward.claim.9': 'Game rebate',
    'oro.disc.claimed': 'Bonus claimed',
    'oro.disc.redeem': 'Redeem code',
    'oro.disc.empty': 'No data',
    'oro.disc.ph': 'Enter redeem code',
    'oro.disc.fail': 'Could not redeem the code',
    'oro.disc.ok': 'Redeemed successfully. +{amount}',
    'oro.disc.claimOk': 'Reward claimed. +{amount}',
    'oro.disc.claimFail': 'Could not claim the reward',
    'oro.disc.err.REDEEM_ALREADY_CLAIMED': 'This code was already redeemed',
    'oro.disc.err.REDEEM_CODE_EXHAUSTED': 'This code is no longer available',
    'oro.disc.err.REDEEM_CODE_EXPIRED': 'This code has expired',
    'oro.disc.err.REDEEM_CODE_INVALID': 'Invalid code',
    'oro.disc.err.REDEEM_IP_LIMITED': 'Too many attempts. Try later',
    'oro.disc.tab.permanent': 'My bonuses',
    'oro.disc.tab.permanent-alt': 'Permanent',
    'oro.disc.tab.vip': 'VIP bonuses',
    'oro.disc.tab.prizes': 'My prizes',
    'oro.disc.vip.level': 'Current VIP level',
    'oro.disc.vip.weekLoss': 'Weekly net loss',
    'oro.disc.vip.monthBet': 'Bets this month',
    'oro.disc.vip.todayLoss': 'Yesterday net loss',
    'oro.disc.vip.yesterdayBet': 'Yesterday bets',
    'oro.disc.vip.reward': 'Reward',
    'oro.disc.vip.nextReward': 'Next bonus',
    'oro.disc.vip.granted': 'Already credited',
    'oro.disc.vip.autoHint': 'Credited automatically when you meet the conditions.',
    'oro.disc.vip.manualHint': 'Claim manually when you meet the conditions.',
    'oro.disc.standing.scratch': 'Scratch Card',
    'oro.disc.standing.wheel': 'Wheel',
    'oro.disc.standing.jackpot': 'Jackpot',
    'oro.disc.standing.rescue': 'RECOVER',
    'oro.disc.standing.times': 'Available Times',
    'oro.jackpot.title': 'Jackpot',
    'oro.jackpot.todayReward': 'Today\'s Rewards',
    'oro.jackpot.withdrawable': 'Withdrawable',
    'oro.jackpot.spinsLeft': 'Spins left',
    'oro.jackpot.bonus': 'Bonus',
    'oro.jackpot.taskBetBtn': 'Bet',
    'oro.jackpot.taskDepositBtn': 'Deposit',
    'oro.jackpot.pending': 'Pending for tomorrow {amount}',
    'oro.jackpot.claim': 'Claim',
    'oro.jackpot.claimOk': 'Claimed {amount}',
    'oro.jackpot.draw': 'Draw',
    'oro.jackpot.chances': 'Spins left: {n}',
    'oro.jackpot.confirmDraw': 'Spend {amount} stars for one draw?',
    'oro.jackpot.insufficient': 'Not enough stars',
    'oro.jackpot.noChances': 'No spins left today',
    'oro.jackpot.unavailable': 'Jackpot is unavailable right now',
    'oro.jackpot.complete': 'You completed a prize!',
    'oro.jackpot.tasks': 'Earn spins',
    'oro.jackpot.spinOne': 'spin',
    'oro.jackpot.spinMany': 'spins',
    'oro.jackpot.task.login': 'Daily VIP login · {n} {unit}',
    'oro.jackpot.task.bet': 'Bet {amount} on slots · {n} {unit}',
    'oro.jackpot.task.deposit': 'Deposit {amount} · {n} {unit}',
    'oro.jackpot.taskGo': 'Go',
    'oro.jackpot.taskDone': 'Done',
    'oro.jackpot.rulesTitle': 'How to play',
    'oro.jackpot.rulesCost': 'Each draw costs 1 spin and 20 stars. Stars cannot be withdrawn.',
    'oro.jackpot.rulesCollect': 'Complete MINI, MINOR, MAJOR or GRAND to win a random cash prize in that range.',
    'oro.jackpot.rulesReset': 'At 00:00 every day, the obtained letters and the number of draw attempts will be reset.',
    'oro.jackpot.rulesClaim': 'Cash can be claimed the same day. You can still claim after the event stops.',
    'oro.jackpot.rulesPoints': 'Daily spins depend on your VIP. Bet and deposit tasks use the site timezone.',
    'oro.scratch.title': 'Scratch Card',
    'oro.scratch.introBefore': 'Collect',
    'oro.scratch.introAfter': 'matching cards to redeem the prize.',
    'oro.scratch.cards': 'Your cards',
    'oro.scratch.chances': '{n} scratch cards',
    'oro.scratch.getAttempts': 'Get attempts',
    'oro.scratch.thanks': 'Thanks',
    'oro.scratch.noTickets': 'Finish tasks to get more scratch cards.',
    'oro.scratch.unavailable': 'Scratch cards are unavailable right now.',
    'oro.scratch.redeem': 'Redeem',
    'oro.scratch.redeemWild': 'Redeem wild',
    'oro.scratch.taskTitle': 'Daily tasks',
    'oro.scratch.currentTickets': 'Current tickets: {n}',
    'oro.scratch.cantidad': 'Amount {n}',
    'oro.scratch.goComplete': 'Go',
    'oro.scratch.noData': 'No tasks',
    'oro.scratch.congrats': 'Congratulations!',
    'oro.scratch.confirm': 'Confirm',
    'oro.scratch.rulesH2': 'Rules',
    'oro.scratch.rulesH3': 'Scratch Card',
    'oro.scratch.rulesPlay': 'How to play',
    'oro.scratch.rulesCover': 'Scratch the cover to reveal a card.',
    'oro.scratch.rulesCollect': 'Collect a full set to redeem the cash prize.',
    'oro.scratch.rulesWithdraw': 'Cash prizes follow the configured wagering multiple.',
    'oro.scratch.rulesFair': 'Each card is drawn on the server. Scratching does not change the result.',
    'oro.scratch.rulesJackpot': 'Jackpot',
    'oro.scratch.rulesRestrict': 'One account per person, IP, or device.',
    'oro.scratch.rulesUse': 'Only eligible games count for this promotion.',
    'oro.scratch.rulesTags': 'Slots',
    'oro.scratch.rulesOther': 'The platform may verify and disqualify fraudulent conduct.',
    'oro.scratch.rulesAbuse': 'Abuse, multiple accounts, and hedging are not allowed.',
    'oro.scratch.rulesFinal': 'Orocasino has the final interpretation.',
    'oro.scratch.rulesLuck': 'Play responsibly. 18+ only.',
    'oro.disc.available.claim': 'Claim reward',
    'oro.disc.available.goScratch': 'Go scratch',
    'oro.disc.available.goWheel': 'Go to wheel',
    'oro.disc.available.goUse': 'Use',
    'oro.disc.available.coupon': 'Deposit bonus',
    'oro.disc.available.qty': 'Quantity',
    'oro.disc.available.reward': 'Reward',
    'oro.disc.available.percent': 'Bonus',
    'oro.disc.available.cash': 'Bonus',
    'oro.tut.step1': 'Step 1',
    'oro.tut.step2': 'Step 2',
    'oro.tut.step3': 'Step 3',
    'oro.tut.step1.title': '1. Open the site in Safari.',
    'oro.tut.step2.title': '2. Open the site in Safari.',
    'oro.tut.step3.title': '3. Add to Home Screen.',
    'oro.tut.step1.desc': 'Open Safari on your phone.',
    'oro.tut.step2.desc': 'Open Safari on your phone.',
    'oro.tut.step3.desc': 'Tap "Add to Home Screen".',
    'oro.game.unavailable': 'The game is unavailable right now. Try again later.',
    'oro.game.notFound': 'This game is not available.',
    'oro.game.balanceTooLow': 'Available balance is below 1. Deposit before entering a game.',
    'oro.game.home': 'Back to home',
    'oro.promo.details': 'Details',
    'oro.promo.loading': 'Loading…',
    'oro.promo.loadError': 'Could not load',
    'oro.promo.retry': 'Retry',
    'oro.promo.claiming': 'Claiming…',
    'oro.promo.claim': 'Claim {amount}',
    'oro.promo.claimed': 'Already claimed',
    'oro.promo.locked': 'Not available yet',
    'oro.promo.login': 'Log in to claim',
    'oro.promo.autoGrantHint': 'Credited automatically.',
    'oro.promo.empty': 'No activities',
    'oro.promo.cta': 'Join now',
    'oro.promo.app.title': 'DOWNLOAD THE APP AND GET UP TO',
    'oro.promo.vip.title': 'LEVEL UP TO VIP',
    'oro.promo.cashback.title': 'Weekly VIP cashback',
    'oro.promo.monthly.title': 'MONTHLY VIP INCOME',
    'oro.promo.daily.title': '1% DAILY LOSS COVER',
    'oro.promo.rescue.title': 'RECOVER',
    'oro.promo.rescue.yesterdayLoss': 'Yesterday\'s loss',
    'oro.promo.rescue.claimCost': 'Claiming costs points',
    'oro.promo.rescue.needMin': 'Below the minimum. Need {amount} to claim.',
    'oro.promo.rescue.needMinPlain': 'Not enough loss to claim.',
    'oro.promo.rescue.canClaim': 'You can claim {amount}',
    'oro.promo.rescue.claimedHint': 'Already claimed today.',
    'oro.promo.rescue.loginHint': 'Log in to see yesterday\'s loss.',
    'oro.promo.inviteChest.title': 'Treasure Chest Rewards',
    'oro.promo.inviteChest.valid': 'Valid referrals',
    'oro.promo.inviteChest.next': 'Next chest: {n}',
    'oro.promo.inviteChest.complete': 'You already claimed every chest',
    'oro.promo.inviteChest.ready': '{n} chests ready to claim',
    'oro.promo.inviteChest.tapClaim': 'Claim',
    'oro.promo.inviteChest.claimed': 'Claimed',
    'oro.sign.hero': '7-day newbie check-in tasks',
    'oro.sign.sub': 'Daily rewards',
    'oro.sign.tab.seven': '7-day newbie tasks',
    'oro.sign.tab.daily': 'Tasks',
    'oro.sign.section.seven': '7-day newbie check-in tasks',
    'oro.sign.section.daily': 'Daily tasks',
    'oro.sign.day': 'Day {n}',
    'oro.sign.done': 'Completed',
    'oro.sign.pending': 'Reward pending claim',
    'oro.sign.notStarted': 'Activity not started',
    'oro.sign.expired': 'Expired',
    'oro.sign.chest.unlockHint': 'Bonus chests unlock on day 8 after registration.',
    'oro.sign.chest.progress': 'Earn {need} more to get {reward}',
    'oro.sign.chest.progressMax': 'Max reward reached',
    'oro.sign.chest.accessRewards': 'Check-in rewards',
    'oro.sign.chest.open': 'Open',
    'oro.sign.chest.open10': 'Open 10',
    'oro.sign.chest.checkIn': 'Check-in',
    'oro.sign.chest.checkInWait': 'Check-in ({n}s)',
    'oro.sign.chest.signedToday': 'Already checked in today',
    'oro.sign.chest.signOk': 'Check-in successful',
    'oro.sign.chest.unavailable': 'Not available',
    'oro.sign.chest.claimed': 'Claimed',
    'oro.sign.chest.rewardTitle': 'Congratulations!',
    'oro.sign.chest.claim': 'Claim',
    'oro.sign.chest.goDeposit': 'Deposit',
    'oro.sign.chest.goInvite': 'Invite',
    'oro.sign.chest.goBet': 'Bet',
    'oro.sign.chest.resignTitle': 'Make up check-in',
    'oro.sign.chest.resignBody': 'Use {price} points to recover Day {n}?',
    'oro.sign.chest.bonusLabel': 'Points: {amount}',
    'oro.sign.chest.openedTitle': 'Chest opened!',
    'oro.sign.chest.openedTotal': 'Total: +{amount}',
    'oro.sign.chest.accept': 'OK',
    'oro.sign.chest.insufficient': 'Not enough points',
    'oro.sign.chest.toastBonus': '+{amount}',
    'oro.sign.chest.toastResign': '+ Day {n} chest',
    'oro.sign.chest.task.bet_first': 'Bet ${n}',
    'oro.sign.chest.task.bet_first_vip': 'Bet ${n}',
    'oro.sign.chest.task.deposit_first': 'Deposit ${n}',
    'oro.sign.chest.task.invite_deposit': 'Friend\'s first deposit',
    'oro.sign.tab.chest': 'Bonus chests',
    'oro.sign.invite.cta': 'Invite',
    'oro.sign.invite.summary': 'You invited {n} friends and can earn {amount}',
    'oro.sign.reward.coupon': 'Coupon +{p}%',
    'oro.sign.reward.scratch': 'Scratch card',
    'oro.sign.reward.wheel': 'Wheel spin',
    'oro.sign.claimSuccess': 'Reward claimed',
    'oro.sign.rewardIssued': 'Reward already credited',
    'oro.sign.rewardReceived': 'Reward received',
    'oro.sign.claim': 'Claim reward',
    'oro.sign.goBet': 'Go bet',
    'oro.sign.invite': 'Invite friends',
    'oro.sign.validBet': 'Valid bet',
    'oro.sign.d1.name': 'Day 1 - Sign in to check in',
    'oro.sign.d2.name': 'Day 2 - Sign in to check in',
    'oro.sign.d3.name': 'Day 3 - Bet 10 to check in',
    'oro.sign.d4.name': 'Day 4 - Bet 20 to check in',
    'oro.sign.d5.name': 'Day 5 - Bet 30 to check in',
    'oro.sign.d6.name': 'Day 6 - Bet 50 to check in',
    'oro.sign.d7.name': 'Day 7 - Bet 100 to check in',
    'oro.sign.invite.name': 'Invite 1 valid user',
    'oro.sign.bet100.name': 'Bet 100 on slots',
    'oro.sign.bet1000.name': 'Bet 1000 on slots',
    'oro.sign.bet5000.name': 'Bet 5000 on slots',
    'oro.vip.benefits': 'VIP level and benefits',
    'oro.vip.about': 'About Orocasino',
    'oro.vip.tab.upgrade': 'VIP upgrade bonus',
    'oro.vip.tab.daily': 'Daily rebate',
    'oro.vip.tab.monthly': 'Fixed monthly bonus',
    'oro.vip.tab.weekly': 'Weekly rebate',
    'oro.vip.tab.jackpot': 'Jackpot',
    'oro.vip.col.vip': 'VIP',
    'oro.vip.col.levelBonus': 'Level bonus',
    'oro.vip.col.jackpotSpins': 'Daily spins',
    'oro.vip.col.rebatePct': 'Rebate %',
    'oro.vip.col.maxPrize': 'Max prize',
    'oro.vip.col.validBets': 'Valid bets',
    'oro.vip.col.fixedBonus': 'Fixed bonus',
    'oro.vip.reward.recompensas.title': 'Rewards',
    'oro.vip.reward.diario.title': 'Daily bonus',
    'oro.vip.reward.ayuda.title': 'Aid',
    'oro.vip.reward.mensual.title': 'Monthly bonus',
    'oro.vip.reward.semanal.title': 'Weekly bonus',
    'oro.vip.reward.soporte.title': 'VIP support',
    'oro.vip.reward.cumple.title': 'Birthday',
    'oro.vip.reward.exclusivos.title': 'Exclusive',
    'oro.vip.reward.fisicos.title': 'Physical gifts',
    'oro.vip.reward.fisicos.lock': 'Unlocked',
    'oro.vip.reward.jackpot.title': 'Jackpot',
    'oro.vip.reward.jackpot.desc': 'Each day you get Jackpot spins based on your VIP level. Higher VIP means more chances.',
    'oro.vip.reward.recompensas.desc': 'Each time you reach a new VIP level, you can claim matching rewards. Higher levels mean bigger rewards.',
    'oro.vip.reward.diario.desc': 'Members can receive extra betting bonuses based on daily wagers. The more you bet, the more you earn.',
    'oro.vip.reward.ayuda.desc': 'During short-term swings you can receive exclusive VIP rescue funds to keep play stable.',
    'oro.vip.reward.mensual.desc': 'Based on your membership level and monthly activity, you can receive a monthly bonus.',
    'oro.vip.reward.semanal.desc': 'Stay active to earn weekly bonuses.',
    'oro.vip.reward.soporte.desc': 'Premium members get VIP management: faster replies, priority handling, and personal help.',
    'oro.vip.reward.cumple.desc': 'In your birthday month we send wishes and a special gift.',
    'oro.vip.reward.exclusivos.desc': 'VIP members join exclusive events, limited discounts, special bonuses, and platform perks.',
    'oro.vip.reward.fisicos.desc': 'At certain VIP levels you may receive physical gifts such as premium devices, luxury items, or travel.',
    'oro.vip.faq.0.q': 'What is the Orocasino VIP Club?',
    'oro.vip.faq.0.a': 'Go beyond expectations with an exclusive VIP experience.',
    'oro.vip.faq.1.q': 'What are the benefits of joining the VIP Club?',
    'oro.vip.faq.1.a': 'The VIP Club unlocks insider info, bonuses, higher rebate, VIP events, and a personal manager.',
    'oro.vip.faq.2.q': 'I want to join VIP but do not meet the level yet. What should I do?',
    'oro.vip.faq.2.a': 'Stay active daily, play your games, invite friends, and deposit often.',
    'oro.vip.faq.3.q': 'I am a member and have not received a bonus. Why?',
    'oro.vip.faq.3.a': 'Weekly VIP bonus is paid every 7 days. Monthly every 30 days if you meet the rules.',
    'oro.vip.faq.4.q': 'How do I become a VIP Club member?',
    'oro.vip.faq.4.a': 'When your deposit and bets reach the required totals, you become the matching VIP.',
    'oro.vip.faq.5.q': 'What affects weekly/monthly bonuses?',
    'oro.vip.faq.5.a': 'Your play activity drives earnings. Birthday bonus is the exception.',
    'oro.vip.faq.6.q': 'Are there special offers for VIP Club members?',
    'oro.vip.faq.6.a': 'Yes, many. Your manager will explain the rest.',
    'oro.team.title': 'Team center',
    'oro.team.info': 'Team information',
    'oro.team.validFriends': 'Total valid friends',
    'oro.team.todayBets': 'Total bet today',
    'oro.team.forecast': 'Based on today\'s live data, the next rank forecast is: {status}',
    'oro.team.rankTip': 'Team rank updates at midnight from yesterday\'s data; progress uses today\'s live data.',
    'oro.team.rewardLv0': 'Level 0 reward',
    'oro.team.rewardLv': 'Level {level} reward',
    'oro.team.nivel': 'Level {level}',
    'oro.team.rewardText': 'Get up to 5% rebate on deposits',
    'oro.team.refLink': 'Referral link',
    'oro.team.invite': 'Invite friends',
    'oro.team.distributed': 'Distributed bonus',
    'oro.team.sentTotal': 'Total sent so far',
    'oro.team.commission': 'Commission',
    'oro.team.faq': 'FAQ',
    'oro.team.paidToday': 'Bonus paid today MXN0.00',
    'oro.team.refDeposit': 'Referral deposit bonus',
    'oro.team.delay': 'Rewards may be delayed',
    'oro.team.claimNow': 'Claim now',
    'oro.team.rebateLog': 'Rebate reward log',
    'oro.team.refBonus': 'Referral bonus',
    'oro.team.inviteLead': 'Invite a friend to join.',
    'oro.team.friendGot': 'Your friend received',
    'oro.team.inviteProgress': 'Today\'s invite progress: 0/999',
    'oro.team.depositBonus': 'Deposit amount / Bonus',
    'oro.team.depositAmt': 'Deposit amount',
    'oro.team.anyDeposit': 'Any deposit',
    'oro.team.friendDepositPercentDesc': 'When your friend deposits any amount, you receive the same percentage.',
    'oro.team.bonus': 'Bonus',
    'oro.team.howPromo': 'How do I get promotion bonuses?',
    'oro.team.whatPlan': 'What is the team dividend plan?',
    'oro.team.howEarn': 'How do I earn promotion bonuses?',
    'oro.team.lv': 'Team level',
    'oro.team.members': 'Team members',
    'oro.team.volume': 'Team volume (bets)',
    'oro.team.notes': 'Notes / Rules:',
    'oro.team.calc': 'Commission calculator',
    'oro.team.calcRate': 'Commission rate: 10%',
    'oro.team.calcLabel': 'Enter valid volume',
    'oro.team.calcPh': 'Commission rate (%)',
    'oro.team.settleTitle': 'Commission settlement and withdrawal',
    'oro.team.settleAmt': 'Settled commission total',
    'oro.team.settle1': 'Settlement: daily at 00:00 (UTC+8)',
    'oro.team.settle2': 'Withdrawal: to card/wallet within 24 hours',
    'oro.team.settle3': 'Minimum withdrawal: 0.00',
    'oro.team.settle4': 'Requirement: identity verification',
    'oro.team.refSub': 'Invite friends to join and earn bonuses.',
    'oro.team.copied': 'Link copied',
    'oro.team.tab.dashboard': 'Dashboard',
    'oro.team.tab.bonus': 'My bonus',
    'oro.team.tab.referral': 'Referral bonus',
    'oro.team.tab.rules': 'Rules',
    'oro.team.stat.invite': 'Invite friends',
    'oro.team.stat.valid': 'Valid friends',
    'oro.team.stat.today-invite': 'Invites today',
    'oro.team.stat.today-valid': 'Valid today',
    'oro.team.stat.today-deposit': 'Deposits today',
    'oro.team.stat.today-volume': 'Volume today',
    'oro.team.bonus.register': 'Today\'s recommended signup bonus',
    'oro.team.bonus.cashback': 'Betting rebate',
    'oro.team.bonus.bet-bonus': 'Betting rebate bonus',
    'oro.team.step.1.title': 'Share with friends',
    'oro.team.step.1.desc': 'Share your referral link, code, or QR with friends.',
    'oro.team.step.2.title': 'Friends sign up and deposit',
    'oro.team.step.2.desc': 'Invite friends to register and complete their first deposit.',
    'oro.team.step.3.title': 'Earn up to $99,999',
    'oro.team.step.3.desc': 'When friends bet and deposit, you earn commissions.',
    'oro.team.faq.0.q': 'What is the Orocasino affiliate program?',
    'oro.team.faq.0.a': 'Invite friends to sign up and play to earn commissions and rewards.',
    'oro.team.faq.1.q': 'How much does it cost to join?',
    'oro.team.faq.1.a': 'Joining the affiliate program is completely free.',
    'oro.team.faq.2.q': 'How much have I earned?',
    'oro.team.faq.2.a': 'Check your earnings on the dashboard and in My bonus.',
    'oro.team.faq.3.q': 'Do more friends mean better benefits?',
    'oro.team.faq.3.a': 'The more valid friends you invite, the higher your reward level.',
    'oro.share.title': 'Share',
    'oro.share.player': 'Player {name}',
    'oro.share.inviteCode': 'Invite code {code}',
    'oro.share.save': 'Save image',
    'oro.share.link': 'Referral link:',
    'oro.share.codeLabel': 'Invite code:',
    'oro.share.copied': 'Copied',
    'oro.share.copyFail': 'Copy failed',
    'oro.share.saved': 'Saved',
    'oro.share.saveFail': 'Save failed',
    'oro.share.history': 'History',
    'oro.share.received': 'Received',
    'oro.share.sent': 'Distributed',
    'oro.share.depositFriends': 'Friends who deposit',
    'oro.share.recentInvite': 'Recently invited friends',
    'oro.share.recentDeposit': 'Recently depositing friends',
    'oro.hist.type.received': 'Rebate reward log',
    'oro.hist.type.retired': 'Team rebate log',
    'oro.lottery.silver': 'DAILY ROULETTE',
    'oro.lottery.gold': 'DAILY ROULETTE',
    'oro.lottery.diamond': 'MX DAILY ROULETTE',
    'oro.lottery.unlock': 'Unlock {vip}',
    'oro.lottery.times': 'spins',
    'oro.lottery.thanks': 'Thanks',
    'oro.lottery.recent': 'Recent wheel winners',
    'oro.lottery.pending': 'Pending',
    'oro.lottery.needVip': 'VIP {level} or higher is required',
    'oro.lottery.upgrade': 'Upgrade VIP ➔',
    'oro.lottery.rulesBody': 'Spin the wheel for prizes. Higher wheels unlock with VIP.',
    'oro.lottery.noTickets': 'You have no spins.',
    'oro.lottery.unavailable': 'The wheel is unavailable right now.',
    'oro.lottery.congrats': 'Congratulations!',
    'oro.team.inviteEarn': 'Invite friends and earn rewards.',
    'oro.team.historyLink': 'History >',
    'oro.team.friendDepositDesc': 'When your friend deposits, you receive a bonus based on the amount.',
    'oro.team.refDepositNote': 'When your referral deposits again, you receive the matching team-level reward.',
    'oro.team.stepNote': 'Note: agent earnings have no cap. Your effort brings larger rewards.',
    'oro.team.planBody': 'As an agent you recruit sub-agents into your team. Higher team performance means higher dividends.',
    'oro.team.levelNote': 'Rebate and deposit bonuses vary by your team level that day. Team members: current valid users. Team bets: total wagered by downline in a day.',
    'oro.team.calcRun': 'Calculate',
    'oro.team.calcResult': 'Estimated reward',
    'oro.edit.getCode': 'Get verification code',
  },
  'zh-CN': {
    'oro.common.back': '返回',
    'oro.common.close': '关闭',
    'oro.common.confirm': '确认',
    'oro.common.add': '添加',
    'oro.common.save': '保存',
    'oro.common.saving': '保存中…',
    'oro.common.next': '下一步',
    'oro.common.prev': '上一页',
    'oro.common.complete': '完成',
    'oro.common.details': '详情',
    'oro.common.empty': '暂无数据',
    'oro.common.noData': '暂无数据',
    'oro.common.search': '搜索',
    'oro.common.copy': '复制',
    'oro.common.guest': '游客',
    'oro.common.none': '无',
    'oro.common.now': '当前',
    'oro.common.rules': '规则',
    'oro.home.seeAll': '查看全部',
    'oro.home.loadMore': '加载更多',
    'oro.home.hours24': '24 小时',
    'oro.home.bigPrizes': '大奖',
    'oro.home.jackpot': '奖池奖金：',
    'oro.search.title': '搜索游戏',
    'oro.search.placeholder': '搜索游戏名称',
    'oro.search.minChars': '至少输入 2 个字符',
    'oro.search.recommended': '推荐游戏',
    'oro.push.text': '开启推送通知，接收优惠、充值和更多更新',
    'oro.push.subscribe': '订阅',
    'oro.fd.title': '你的首存奖金即将过期',
    'oro.fd.remain': '剩余时间',
    'oro.fd.go': '去充值',
    'oro.deposit.guest': '你正在游客模式。请立即绑定账号，以免换机或删除应用后丢失余额和进度。',
    'oro.deposit.completeProfile': '完善资料',
    'oro.deposit.tab': '充值',
    'oro.deposit.withdrawTab': '提现',
    'oro.deposit.channel': '充值通道',
    'oro.deposit.firstReward': '首存奖励',
    'oro.deposit.cash': '现金',
    'oro.deposit.reward': '奖励',
    'oro.deposit.points': '积分',
    'oro.deposit.total': '合计',
    'oro.deposit.optOut': '不参加此优惠',
    'oro.deposit.cta': '充值 {amount} MXN',
    'oro.deposit.infoTitle': '充值前请查看可参加的优惠。',
    'oro.deposit.infoDesc': '如有疑问请联系客服。',
    'oro.deposit.how': '如何充值',
    'oro.deposit.noAccount': '未检测到账户',
    'oro.deposit.addWithdraw': '添加提现账户',
    'oro.deposit.balance': '余额',
    'oro.deposit.withdrawable': '可提现余额',
    'oro.deposit.withdrawAmount': '提现金额',
    'oro.deposit.withdrawPh': '输入提现金额',
    'oro.deposit.safe': '由官方 Orocasino 与可信第三方提供安全访问。',
    'oro.deposit.safeContact': '如有疑问，请联系我们的',
    'oro.deposit.liveSupport': '在线客服',
    'oro.deposit.tip.0': '完成充值后即可参加活动赢奖励。马上行动！',
    'oro.deposit.tip.1': '请确保充值金额与付款一致，差额可能导致延迟或失败。',
    'oro.deposit.tip.2': '最低充值和提现金额为 50.00 MXN。详情见条款。',
    'oro.wallet.title': '银行卡管理',
    'oro.wallet.addAccount': '添加账户',
    'oro.wallet.addBank': '添加银行卡',
    'oro.wallet.addUsdt': '添加 USDT 钱包地址',
    'oro.wallet.addPix': '添加 PIX',
    'oro.wallet.addEwallet': '添加电子钱包',
    'oro.wallet.accountName': '账户名',
    'oro.wallet.bankName': '银行名称',
    'oro.wallet.bankAccount': '银行账号',
    'oro.wallet.walletName': '钱包名称',
    'oro.wallet.currency': '币种',
    'oro.wallet.chain': '链',
    'oro.wallet.walletAddr': '钱包地址',
    'oro.wallet.notes': '备注',
    'oro.wallet.noteExchange': '请添加你自己的交易所钱包。',
    'oro.wallet.usdtOnly': '仅支持 USDT {chain} 地址。',
    'oro.wallet.usdtPh': '输入 USDT {chain} 地址',
    'oro.wallet.holder': '持有人姓名',
    'oro.wallet.pixType': '密钥类型',
    'oro.wallet.pixKey': '密钥',
    'oro.wallet.ewalletNo': '钱包号码',
    'oro.wallet.contactSupport': '请联系客服',
    'oro.wallet.ph.account': '请输入账户名',
    'oro.wallet.ph.bank': '请输入银行名称',
    'oro.wallet.ph.bankAcc': '请输入银行账号',
    'oro.wallet.ph.wallet': '请输入钱包名称',
    'oro.wallet.ph.holder': '请输入持有人姓名',
    'oro.wallet.ph.ewallet': '请输入钱包号码',
    'oro.wallet.err.account': '请输入账户名',
    'oro.wallet.err.bank': '请输入银行名称',
    'oro.wallet.err.bankAcc': '请输入银行账号',
    'oro.wallet.err.holder': '请输入持有人姓名',
    'oro.wallet.err.ewallet': '请输入钱包号码',
    'oro.wallet.err.addr': '请输入收款地址',
    'oro.wallet.err.trcStart': 'TRC-20 地址必须以 T 开头',
    'oro.wallet.err.trcLen': 'TRC-20 地址必须为 34 位',
    'oro.wallet.err.addrStart': '{chain} 地址必须以 {prefix} 开头',
    'oro.wallet.err.addrLen': '{chain} 地址必须为 {n} 位',
    'oro.wallet.err.walletName': '请输入钱包名称',
    'oro.wallet.err.chain': '请选择链',
    'oro.wallet.err.pixKey': '请输入密钥',
    'oro.wallet.err.required': '请填写{field}',
    'oro.wallet.err.digits': '{field}须为{n}位数字',
    'oro.wallet.err.invalid': '{field}格式不正确',
    'oro.wallet.err.binMismatch': '{field}与所选银行不匹配',
    'oro.wallet.binHint': '卡号必须属于所选银行',
    'oro.wallet.delete': '删除',
    'oro.wallet.deleted': '已删除',
    'oro.wallet.empty': '暂无账户',
    'oro.wallet.saved': '已保存',
    'oro.wallet.tab.bank_card': '银行卡',
    'oro.wallet.tab.usdt': 'USDT',
    'oro.wallet.tab.e_wallet': '电子钱包',
    'oro.wallet.tab.pix': 'PIX',
    'oro.edit.title': '编辑资料',
    'oro.edit.avatar': '用户头像',
    'oro.edit.realName': '真实姓名',
    'oro.edit.realNamePh': '请输入真实姓名',
    'oro.edit.loginName': '登录账号',
    'oro.edit.loginNamePh': '请输入登录账号',
    'oro.edit.loginReadonly': '正式账号不可修改。',
    'oro.edit.password': '登录密码',
    'oro.edit.passwordPh': '6-16 位密码',
    'oro.edit.hint': '请避免特殊字符，否则账户可能不兼容。',
    'oro.edit.birthday': '出生日期',
    'oro.edit.datePh': '日 / 月 / 年',
    'oro.edit.phone': '手机号',
    'oro.edit.codePh': '请输入验证码',
    'oro.edit.email': '电子邮箱',
    'oro.edit.errAccount': '账号需为 3-64 位字母、数字或 . _ @ -',
    'oro.edit.errPassword': '密码需为 6-16 位。',
    'oro.edit.errRealName': '真实姓名需为 2-96 个字符。',
    'oro.edit.errPhone': '请输入 10 位墨西哥手机号。',
    'oro.edit.errEmail': '请输入有效邮箱。',
    'oro.edit.errBirthday': '需年满 18 岁。',
    'oro.edit.errTaken': '该登录账号已被占用。',
    'oro.edit.errPhoneTaken': '该手机号已被占用。',
    'oro.edit.errEmailTaken': '该邮箱已被占用。',
    'oro.sec.title': '安全设置',
    'oro.sec.low': '低',
    'oro.sec.pwdTitle': '设置登录密码。',
    'oro.sec.pwdDesc': '请定期更改密码以保持安全。',
    'oro.sec.mailTitle': '邮箱验证',
    'oro.sec.mailDesc': '验证邮箱以提高账户安全。',
    'oro.sec.sessions': '会话数',
    'oro.sec.device': '设备',
    'oro.sec.action': '操作',
    'oro.rec.tx': '交易',
    'oro.rec.bets': '投注记录',
    'oro.rec.moves': '资金变动',
    'oro.rec.biz.ACTIVITY_REWARD': '活动奖励',
    'oro.rec.biz.DEPOSIT': '充值',
    'oro.rec.biz.DEPOSIT_REBATE': '充值返利',
    'oro.rec.biz.GAME_REBATE': '游戏返水',
    'oro.rec.biz.GAME_SPIN': '投注',
    'oro.rec.biz.GIFT_BONUS': '赠送奖励',
    'oro.rec.biz.MANUAL_CREDIT': '人工加款',
    'oro.rec.biz.MANUAL_DEBIT': '人工扣款',
    'oro.rec.biz.REDEEM_CODE': '兑换码奖励',
    'oro.rec.biz.REFERRAL_BONUS': '邀请奖励',
    'oro.rec.biz.TASK_REWARD': '任务奖励',
    'oro.rec.biz.VIP_BONUS': 'VIP奖励',
    'oro.rec.biz.WHEEL_BONUS': '转盘奖励',
    'oro.rec.biz.WITHDRAW': '提现',
    'oro.rec.biz.WITHDRAW_HOLD': '提现冻结',
    'oro.rec.biz.WITHDRAW_REFUND': '提现退回',
    'oro.rec.biz.WITHDRAW_UNHOLD': '提现解冻',
    'oro.rec.biz.WUFU_BONUS': '五福奖励',
    'oro.filter.today': '今天',
    'oro.filter.three_days': '近 3 天',
    'oro.filter.seven_days': '近 7 天',
    'oro.filter.half_month': '近 15 天',
    'oro.filter.one_month': '近 30 天',
    'oro.filter.yesterday': '昨天',
    'oro.filter.month': '本月',
    'oro.filter.deposit': '充值',
    'oro.filter.withdraw': '提现',
    'oro.filter.all': '全部',
    'oro.filter.allLevels': '全部',
    'oro.filter.level.1': '1 级',
    'oro.filter.level.2': '2 级',
    'oro.filter.level.3': '3 级',
    'oro.notice.title': '通知',
    'oro.notice.empty': '暂无消息',
    'oro.notice.platform': '平台',
    'oro.notice.personal': '个人',
    'oro.reward.title': '奖励详情',
    'oro.reward.conditions': '奖励条件',
    'oro.reward.tx': '交易',
    'oro.reward.allBonus': '全部奖金',
    'oro.reward.type': '奖励类型',
    'oro.reward.amount': '奖励金额',
    'oro.reward.time': '时间',
    'oro.reward.footnote': '显示最近 90 天数据',
    'oro.reward.claim.0': '赠送彩金',
    'oro.reward.claim.1': '等级彩金',
    'oro.reward.claim.2': '活动优惠',
    'oro.reward.claim.3': '任务奖励',
    'oro.reward.claim.4': '免费转盘',
    'oro.reward.claim.5': '五福',
    'oro.reward.claim.6': '推广奖励',
    'oro.reward.claim.7': '领取码',
    'oro.reward.claim.8': '充值返利',
    'oro.reward.claim.9': '游戏返水',
    'oro.disc.claimed': '已领奖金',
    'oro.disc.redeem': '兑换码',
    'oro.disc.empty': '暂无数据',
    'oro.disc.ph': '请输入兑换码',
    'oro.disc.fail': '兑换失败',
    'oro.disc.ok': '兑换成功，已到账 {amount}',
    'oro.disc.claimOk': '领取成功，已到账 {amount}',
    'oro.disc.claimFail': '领取失败',
    'oro.disc.err.REDEEM_ALREADY_CLAIMED': '该码已被兑换',
    'oro.disc.err.REDEEM_CODE_EXHAUSTED': '该码已用完',
    'oro.disc.err.REDEEM_CODE_EXPIRED': '该码已过期',
    'oro.disc.err.REDEEM_CODE_INVALID': '无效兑换码',
    'oro.disc.err.REDEEM_IP_LIMITED': '尝试过多，请稍后再试',
    'oro.disc.tab.permanent': '我的奖金',
    'oro.disc.tab.permanent-alt': '常驻奖金',
    'oro.disc.tab.vip': 'VIP 奖金',
    'oro.disc.tab.prizes': '我的奖品',
    'oro.disc.vip.level': '当前 VIP 等级',
    'oro.disc.vip.weekLoss': '本周净亏损',
    'oro.disc.vip.monthBet': '本月投注',
    'oro.disc.vip.todayLoss': '昨日净亏损',
    'oro.disc.vip.yesterdayBet': '昨日投注',
    'oro.disc.vip.reward': '奖励',
    'oro.disc.vip.nextReward': '下档奖励',
    'oro.disc.vip.granted': '已到账',
    'oro.disc.vip.autoHint': '满足条件后自动发放。',
    'oro.disc.vip.manualHint': '满足条件后需手动领取。',
    'oro.disc.standing.scratch': '刮刮卡',
    'oro.disc.standing.wheel': '转盘',
    'oro.disc.standing.jackpot': '字母奖池',
    'oro.disc.standing.rescue': '日救援金',
    'oro.disc.standing.times': '可用次数',
    'oro.jackpot.title': '字母奖池',
    'oro.jackpot.todayReward': '今日可领',
    'oro.jackpot.withdrawable': '可提现',
    'oro.jackpot.spinsLeft': '剩余次数',
    'oro.jackpot.bonus': '积分',
    'oro.jackpot.taskBetBtn': '投注',
    'oro.jackpot.taskDepositBtn': '充值',
    'oro.jackpot.pending': '次日待领 {amount}',
    'oro.jackpot.claim': '领取',
    'oro.jackpot.claimOk': '已领取 {amount}',
    'oro.jackpot.draw': '抽奖',
    'oro.jackpot.chances': '剩余次数：{n}',
    'oro.jackpot.confirmDraw': '消耗 {amount} 积分抽一次？',
    'oro.jackpot.insufficient': '积分不足',
    'oro.jackpot.noChances': '今日次数已用完',
    'oro.jackpot.unavailable': '奖池暂不可用',
    'oro.jackpot.complete': '集齐一档奖金！',
    'oro.jackpot.tasks': '获取次数',
    'oro.jackpot.spinOne': '次',
    'oro.jackpot.spinMany': '次',
    'oro.jackpot.task.login': 'VIP 每日登录 · {n} {unit}',
    'oro.jackpot.task.bet': '老虎机投注 {amount} · {n} {unit}',
    'oro.jackpot.task.deposit': '充值 {amount} · {n} {unit}',
    'oro.jackpot.taskGo': '去完成',
    'oro.jackpot.taskDone': '已完成',
    'oro.jackpot.rulesTitle': '玩法说明',
    'oro.jackpot.rulesCost': '每次抽奖消耗 1 次机会和 20 积分。积分不可提现。',
    'oro.jackpot.rulesCollect': '集齐 MINI / MINOR / MAJOR / GRAND 字母，随机获得该档现金。',
    'oro.jackpot.rulesReset': '每天 00:00 重置已获得的字母和抽奖次数。',
    'oro.jackpot.rulesClaim': '集齐当天可领现金。每档每天最多齐 1 次。活动停用后仍可领取已入账金额。',
    'oro.jackpot.rulesPoints': '每日次数按 VIP。投注和充值任务按站点时区统计。',
    'oro.scratch.title': '刮刮卡',
    'oro.scratch.introBefore': '集齐',
    'oro.scratch.introAfter': '张相同卡即可兑奖。',
    'oro.scratch.cards': '我的卡券',
    'oro.scratch.chances': '{n} 张刮刮卡',
    'oro.scratch.getAttempts': '获取次数',
    'oro.scratch.thanks': '谢谢惠顾',
    'oro.scratch.noTickets': '完成任务可获得更多刮刮卡。',
    'oro.scratch.unavailable': '刮刮卡暂不可用。',
    'oro.scratch.redeem': '兑换',
    'oro.scratch.redeemWild': '兑换万能卡',
    'oro.scratch.taskTitle': '每日任务',
    'oro.scratch.currentTickets': '当前次数：{n}',
    'oro.scratch.cantidad': '数量 {n}',
    'oro.scratch.goComplete': '去完成',
    'oro.scratch.noData': '暂无任务',
    'oro.scratch.congrats': '恭喜',
    'oro.scratch.confirm': '确认',
    'oro.scratch.rulesH2': '规则',
    'oro.scratch.rulesH3': '刮刮卡',
    'oro.scratch.rulesPlay': '玩法',
    'oro.scratch.rulesCover': '刮开封面即可亮出一张卡。',
    'oro.scratch.rulesCollect': '集齐一套即可兑换现金奖。',
    'oro.scratch.rulesWithdraw': '现金奖按配置的打码倍数计算。',
    'oro.scratch.rulesFair': '每次刮奖在服务端开奖，刮开不会改结果。',
    'oro.scratch.rulesJackpot': '大奖',
    'oro.scratch.rulesRestrict': '同一人、IP 或设备仅限一个账户。',
    'oro.scratch.rulesUse': '仅统计本活动允许的游戏。',
    'oro.scratch.rulesTags': '老虎机',
    'oro.scratch.rulesOther': '平台可核验并取消作弊资格。',
    'oro.scratch.rulesAbuse': '禁止滥用、多开和对冲投注。',
    'oro.scratch.rulesFinal': '最终解释权归 Orocasino。',
    'oro.scratch.rulesLuck': '请理性游戏。未满 18 岁禁止。',
    'oro.disc.available.claim': '领取奖励',
    'oro.disc.available.goScratch': '去刮奖',
    'oro.disc.available.goWheel': '去转盘',
    'oro.disc.available.goUse': '去使用',
    'oro.disc.available.coupon': '存款优惠',
    'oro.disc.available.qty': '数量',
    'oro.disc.available.reward': '奖励',
    'oro.disc.available.percent': '优惠',
    'oro.disc.available.cash': '奖金',
    'oro.tut.step1': '第 1 步',
    'oro.tut.step2': '第 2 步',
    'oro.tut.step3': '第 3 步',
    'oro.tut.step1.title': '1. 在 Safari 中打开网站。',
    'oro.tut.step2.title': '2. 在 Safari 中打开网站。',
    'oro.tut.step3.title': '3. 添加到主屏幕。',
    'oro.tut.step1.desc': '在手机上打开 Safari。',
    'oro.tut.step2.desc': '在手机上打开 Safari。',
    'oro.tut.step3.desc': '点击「添加到主屏幕」。',
    'oro.game.unavailable': '暂时无法进入游戏，请稍后再试。',
    'oro.game.notFound': '该游戏不存在或已下架。',
    'oro.game.balanceTooLow': '可用余额不足 1，请先充值再进入游戏。',
    'oro.game.home': '返回首页',
    'oro.promo.details': '详情',
    'oro.promo.loading': '加载中…',
    'oro.promo.loadError': '加载失败',
    'oro.promo.retry': '重试',
    'oro.promo.claiming': '领取中…',
    'oro.promo.claim': '领取 {amount}',
    'oro.promo.claimed': '已领取',
    'oro.promo.locked': '暂未解锁',
    'oro.promo.login': '登录后领取',
    'oro.promo.autoGrantHint': '系统自动入账。',
    'oro.promo.empty': '暂无活动',
    'oro.promo.cta': '立即参与',
    'oro.promo.app.title': '下载 APP 最高可得',
    'oro.promo.vip.title': '升级 VIP',
    'oro.promo.cashback.title': '每周 VIP 返水',
    'oro.promo.monthly.title': '每月 VIP 收益',
    'oro.promo.daily.title': '每日亏损 1%',
    'oro.promo.rescue.title': '救援金',
    'oro.promo.rescue.yesterdayLoss': '昨日亏损',
    'oro.promo.rescue.claimCost': '领取需要消耗对应金额的积分',
    'oro.promo.rescue.needMin': '未达最低档，需满 {amount} 才可领取',
    'oro.promo.rescue.needMinPlain': '未达最低档，暂不可领取',
    'oro.promo.rescue.canClaim': '可领 {amount}',
    'oro.promo.rescue.claimedHint': '今日已领取',
    'oro.promo.rescue.loginHint': '登录后查看昨日亏损',
    'oro.promo.inviteChest.title': '宝箱奖励',
    'oro.promo.inviteChest.valid': '有效邀请',
    'oro.promo.inviteChest.next': '下一档：{n}',
    'oro.promo.inviteChest.complete': '宝箱已全部领取',
    'oro.promo.inviteChest.ready': '{n} 个宝箱可领取',
    'oro.promo.inviteChest.tapClaim': '领取',
    'oro.promo.inviteChest.claimed': '已领取',
    'oro.sign.hero': '新人 7 日签到任务',
    'oro.sign.sub': '每日奖励',
    'oro.sign.tab.seven': '新人 7 日任务',
    'oro.sign.tab.daily': '任务',
    'oro.sign.section.seven': '新人 7 日签到任务',
    'oro.sign.section.daily': '每日任务',
    'oro.sign.day': '第 {n} 天',
    'oro.sign.done': '已完成',
    'oro.sign.pending': '待领取',
    'oro.sign.notStarted': '活动未开始',
    'oro.sign.expired': '已过期',
    'oro.sign.chest.unlockHint': '注册满 8 天解锁 Bonus 宝箱。',
    'oro.sign.chest.progress': '再赚 {need} 即可获得 {reward}',
    'oro.sign.chest.progressMax': '已达最高奖励',
    'oro.sign.chest.accessRewards': '签到奖励',
    'oro.sign.chest.open': '开启',
    'oro.sign.chest.open10': '开 10 个',
    'oro.sign.chest.checkIn': '签到',
    'oro.sign.chest.checkInWait': '签到（{n}s）',
    'oro.sign.chest.signedToday': '今天已签到',
    'oro.sign.chest.signOk': '签到成功',
    'oro.sign.chest.unavailable': '暂不可用',
    'oro.sign.chest.claimed': '已领取',
    'oro.sign.chest.rewardTitle': '恭喜',
    'oro.sign.chest.claim': '领取',
    'oro.sign.chest.goDeposit': '去充值',
    'oro.sign.chest.goInvite': '去邀请',
    'oro.sign.chest.goBet': '去投注',
    'oro.sign.chest.resignTitle': '补签',
    'oro.sign.chest.resignBody': '使用 {price} 积分补签第 {n} 天？',
    'oro.sign.chest.bonusLabel': '积分：{amount}',
    'oro.sign.chest.openedTitle': '宝箱已开启！',
    'oro.sign.chest.openedTotal': '合计：+{amount}',
    'oro.sign.chest.accept': '确定',
    'oro.sign.chest.insufficient': '积分不足',
    'oro.sign.chest.toastBonus': '+{amount}',
    'oro.sign.chest.toastResign': '+ 第 {n} 天宝箱',
    'oro.sign.chest.task.bet_first': '投注 ${n}',
    'oro.sign.chest.task.bet_first_vip': '投注 ${n}',
    'oro.sign.chest.task.deposit_first': '充值 ${n}',
    'oro.sign.chest.task.invite_deposit': '邀请好友首充',
    'oro.sign.tab.chest': 'Bonus 宝箱',
    'oro.sign.invite.cta': '去邀请',
    'oro.sign.invite.summary': '已邀请 {n} 人，可领 {amount}',
    'oro.sign.reward.coupon': '优惠券 +{p}%',
    'oro.sign.reward.scratch': '刮刮卡',
    'oro.sign.reward.wheel': '转盘次数',
    'oro.sign.claimSuccess': '领取成功',
    'oro.sign.rewardIssued': '奖励已发放',
    'oro.sign.rewardReceived': '奖励已到账',
    'oro.sign.claim': '领取奖励',
    'oro.sign.goBet': '去投注',
    'oro.sign.invite': '邀请好友',
    'oro.sign.validBet': '有效投注',
    'oro.sign.d1.name': '第 1 天 - 登录签到',
    'oro.sign.d2.name': '第 2 天 - 登录签到',
    'oro.sign.d3.name': '第 3 天 - 投注 10 签到',
    'oro.sign.d4.name': '第 4 天 - 投注 20 签到',
    'oro.sign.d5.name': '第 5 天 - 投注 30 签到',
    'oro.sign.d6.name': '第 6 天 - 投注 50 签到',
    'oro.sign.d7.name': '第 7 天 - 投注 100 签到',
    'oro.sign.invite.name': '邀请 1 位有效用户',
    'oro.sign.bet100.name': '老虎机投注 100',
    'oro.sign.bet1000.name': '老虎机投注 1000',
    'oro.sign.bet5000.name': '老虎机投注 5000',
    'oro.vip.benefits': 'VIP 等级与权益',
    'oro.vip.about': '关于 Orocasino',
    'oro.vip.tab.upgrade': 'VIP 升级奖金',
    'oro.vip.tab.daily': '每日返水',
    'oro.vip.tab.monthly': '每月固定奖金',
    'oro.vip.tab.weekly': '每周返水',
    'oro.vip.tab.jackpot': '奖池抽奖',
    'oro.vip.col.vip': 'VIP',
    'oro.vip.col.levelBonus': '等级奖金',
    'oro.vip.col.jackpotSpins': '每日次数',
    'oro.vip.col.rebatePct': '返水比例',
    'oro.vip.col.maxPrize': '最高奖金',
    'oro.vip.col.validBets': '有效投注',
    'oro.vip.col.fixedBonus': '固定奖金',
    'oro.vip.reward.recompensas.title': '奖励',
    'oro.vip.reward.diario.title': '每日奖金',
    'oro.vip.reward.ayuda.title': '救援',
    'oro.vip.reward.mensual.title': '每月奖金',
    'oro.vip.reward.semanal.title': '每周奖金',
    'oro.vip.reward.soporte.title': 'VIP 客服',
    'oro.vip.reward.cumple.title': '生日',
    'oro.vip.reward.exclusivos.title': '专属',
    'oro.vip.reward.fisicos.title': '实物礼品',
    'oro.vip.reward.fisicos.lock': '已解锁',
    'oro.vip.reward.jackpot.title': '奖池抽奖',
    'oro.vip.reward.jackpot.desc': '每日登录按 VIP 等级获赠奖池抽奖次数，等级越高次数越多。',
    'oro.vip.reward.recompensas.desc': '每升一级 VIP 即可领取对应奖励，等级越高奖励越大。',
    'oro.vip.reward.diario.desc': '会员可按每日投注额领取额外奖金，投注越多奖励越高。',
    'oro.vip.reward.ayuda.desc': '短期波动时可领取专属 VIP 救援金，保持稳定体验。',
    'oro.vip.reward.mensual.desc': '按会员等级与月活跃度发放月奖金。',
    'oro.vip.reward.semanal.desc': '保持活跃即可领取周奖金。',
    'oro.vip.reward.soporte.desc': '高级会员享专属 VIP 管家：快速响应、优先处理和个性化协助。',
    'oro.vip.reward.cumple.desc': '生日当月送上祝福与专属礼物。',
    'oro.vip.reward.exclusivos.desc': 'VIP 可参加专属活动、限时折扣与平台特权。',
    'oro.vip.reward.fisicos.desc': '达到指定 VIP 等级可获实物礼品。',
    'oro.vip.faq.0.q': '什么是 Orocasino VIP 俱乐部？',
    'oro.vip.faq.0.a': '成为 VIP，享受超预期的专属体验。',
    'oro.vip.faq.1.q': '加入 VIP 俱乐部有哪些权益？',
    'oro.vip.faq.1.a': 'VIP 俱乐部可解锁一手资讯、奖金、更高返水、专属活动与专属经理。',
    'oro.vip.faq.2.q': '想加入 VIP 但还没达标，该怎么办？',
    'oro.vip.faq.2.a': '保持每日活跃、游玩、邀请好友并经常充值。',
    'oro.vip.faq.3.q': '我已是会员却还没收到奖金，为什么？',
    'oro.vip.faq.3.a': '周奖金每 7 天发放，月奖金每 30 天发放（需达标）。',
    'oro.vip.faq.4.q': '如何成为 VIP 俱乐部成员？',
    'oro.vip.faq.4.a': '充值和投注达到标准后即成为对应 VIP。',
    'oro.vip.faq.5.q': '什么会影响周/月奖金？',
    'oro.vip.faq.5.a': '收益主要取决于游戏活跃度；生日奖金除外。',
    'oro.vip.faq.6.q': 'VIP 俱乐部成员有特别优惠吗？',
    'oro.vip.faq.6.a': '有，你的专属经理会详细说明。',
    'oro.team.title': '团队中心',
    'oro.team.info': '团队信息',
    'oro.team.validFriends': '有效好友总数',
    'oro.team.todayBets': '今日总投注',
    'oro.team.forecast': '按今日实时数据，下一评级预计为：{status}',
    'oro.team.rankTip': '团队等级每天午夜按昨日数据更新；进度按今日实时数据。',
    'oro.team.rewardLv0': '0 级奖励',
    'oro.team.rewardLv': '{level} 级奖励',
    'oro.team.nivel': '{level} 级',
    'oro.team.rewardText': '充值最高返 5%',
    'oro.team.refLink': '推荐链接',
    'oro.team.invite': '邀请好友',
    'oro.team.distributed': '已发放奖金',
    'oro.team.sentTotal': '累计已发放',
    'oro.team.commission': '佣金',
    'oro.team.faq': '常见问题',
    'oro.team.paidToday': '今日已付奖金 MXN0.00',
    'oro.team.refDeposit': '推荐充值奖金',
    'oro.team.delay': '奖励可能延迟到账',
    'oro.team.claimNow': '立即领取',
    'oro.team.rebateLog': '返利奖励记录',
    'oro.team.refBonus': '推荐奖金',
    'oro.team.inviteLead': '邀请好友一起参与。',
    'oro.team.friendGot': '好友已获得',
    'oro.team.inviteProgress': '今日邀请进度：0/999',
    'oro.team.depositBonus': '充值金额 / 奖金',
    'oro.team.depositAmt': '充值金额',
    'oro.team.anyDeposit': '任意充值',
    'oro.team.friendDepositPercentDesc': '好友任意金额充值，均按同一比例赠送。',
    'oro.team.bonus': '奖金',
    'oro.team.howPromo': '如何获得推广奖金？',
    'oro.team.whatPlan': '什么是团队分红计划？',
    'oro.team.howEarn': '如何赚取推广奖金？',
    'oro.team.lv': '团队等级',
    'oro.team.members': '团队成员',
    'oro.team.volume': '团队流水（投注）',
    'oro.team.notes': '备注 / 规则：',
    'oro.team.calc': '佣金计算器',
    'oro.team.calcRate': '佣金比例：10%',
    'oro.team.calcLabel': '输入有效流水',
    'oro.team.calcPh': '佣金比例 (%)',
    'oro.team.settleTitle': '佣金结算与提现',
    'oro.team.settleAmt': '累计已结算佣金',
    'oro.team.settle1': '结算：每日 00:00（UTC+8）',
    'oro.team.settle2': '提现：24 小时内到卡/钱包',
    'oro.team.settle3': '最低提现：0.00',
    'oro.team.settle4': '要求：身份验证',
    'oro.team.refSub': '邀请好友加入即可获得奖金。',
    'oro.team.copied': '链接已复制',
    'oro.team.tab.dashboard': '控制台',
    'oro.team.tab.bonus': '我的奖金',
    'oro.team.tab.referral': '推荐奖金',
    'oro.team.tab.rules': '规则',
    'oro.team.stat.invite': '邀请好友',
    'oro.team.stat.valid': '有效好友',
    'oro.team.stat.today-invite': '今日邀请',
    'oro.team.stat.today-valid': '今日有效',
    'oro.team.stat.today-deposit': '今日充值',
    'oro.team.stat.today-volume': '今日流水',
    'oro.team.bonus.register': '今日推荐注册奖金',
    'oro.team.bonus.cashback': '投注返水',
    'oro.team.bonus.bet-bonus': '投注返利奖金',
    'oro.team.step.1.title': '分享给好友',
    'oro.team.step.1.desc': '把推荐链接、推荐码或二维码分享给好友。',
    'oro.team.step.2.title': '好友注册并充值',
    'oro.team.step.2.desc': '邀请好友注册并完成首充。',
    'oro.team.step.3.title': '最高可赚 $99,999',
    'oro.team.step.3.desc': '好友投注和充值后，你可获得佣金。',
    'oro.team.faq.0.q': 'Orocasino 代理计划是什么？',
    'oro.team.faq.0.a': '邀请好友注册游戏即可赚取佣金和奖励。',
    'oro.team.faq.1.q': '参与需要费用吗？',
    'oro.team.faq.1.a': '代理计划完全免费。',
    'oro.team.faq.2.q': '我赚了多少？',
    'oro.team.faq.2.a': '可在控制台和「我的奖金」查看累计收益。',
    'oro.team.faq.3.q': '好友越多收益越好吗？',
    'oro.team.faq.3.a': '有效好友越多，奖励等级越高。',
    'oro.share.title': '分享',
    'oro.share.player': '玩家 {name}',
    'oro.share.inviteCode': '邀请码 {code}',
    'oro.share.save': '保存图片',
    'oro.share.link': '推荐链接：',
    'oro.share.codeLabel': '邀请码：',
    'oro.share.copied': '复制成功',
    'oro.share.copyFail': '复制失败',
    'oro.share.saved': '保存成功',
    'oro.share.saveFail': '保存失败',
    'oro.share.history': '历史',
    'oro.share.received': '已收',
    'oro.share.sent': '已发放',
    'oro.share.depositFriends': '充值好友',
    'oro.share.recentInvite': '近期邀请好友',
    'oro.share.recentDeposit': '近期充值好友',
    'oro.hist.type.received': '返利奖励记录',
    'oro.hist.type.retired': '团队返利记录',
    'oro.lottery.silver': '每日转盘',
    'oro.lottery.gold': '每日转盘',
    'oro.lottery.diamond': 'MX 每日转盘',
    'oro.lottery.unlock': '{vip} 解锁',
    'oro.lottery.times': '次',
    'oro.lottery.thanks': '谢谢',
    'oro.lottery.recent': '近期转盘大奖',
    'oro.lottery.pending': '待解锁',
    'oro.lottery.needVip': '需要 VIP {level} 或以上',
    'oro.lottery.upgrade': '提升 VIP ➔',
    'oro.lottery.rulesBody': '转动转盘赢奖。更高等级转盘需 VIP 解锁。',
    'oro.lottery.noTickets': '抽奖次数不足',
    'oro.lottery.unavailable': '转盘暂不可用。',
    'oro.lottery.congrats': '恭喜获得',
    'oro.team.inviteEarn': '邀请好友赢奖励。',
    'oro.team.historyLink': '历史 >',
    'oro.team.friendDepositDesc': '好友充值后，你将按金额获得奖金。',
    'oro.team.refDepositNote': '下级再次充值时，按团队等级发放对应奖励。',
    'oro.team.stepNote': '备注：代理收益无上限，付出越多回报越大。',
    'oro.team.planBody': '作为代理招募下级组成团队，团队业绩越高分红越高。',
    'oro.team.levelNote': '返利和充值奖金按当日团队等级变化。团队成员为当前有效用户。团队投注为下级当日总流水。',
    'oro.team.calcRun': '计算',
    'oro.team.calcResult': '预估奖励',
    'oro.edit.getCode': '获取验证码',
  },
  'zh-TW': {
    'oro.common.back': '返回',
    'oro.common.close': '關閉',
    'oro.common.confirm': '確認',
    'oro.common.add': '新增',
    'oro.common.save': '儲存',
    'oro.common.saving': '儲存中…',
    'oro.common.next': '下一步',
    'oro.common.prev': '上一頁',
    'oro.common.complete': '完成',
    'oro.common.details': '詳情',
    'oro.common.empty': '暫無資料',
    'oro.common.noData': '暫無資料',
    'oro.common.search': '搜尋',
    'oro.common.copy': '複製',
    'oro.common.guest': '訪客',
    'oro.common.none': '無',
    'oro.common.now': '目前',
    'oro.common.rules': '規則',
    'oro.home.seeAll': '查看全部',
    'oro.home.loadMore': '載入更多',
    'oro.home.hours24': '24 小時',
    'oro.home.bigPrizes': '大獎',
    'oro.home.jackpot': '獎池獎金：',
    'oro.search.title': '搜尋遊戲',
    'oro.search.placeholder': '搜尋遊戲名稱',
    'oro.search.minChars': '至少輸入 2 個字元',
    'oro.search.recommended': '推薦遊戲',
    'oro.push.text': '開啟推播通知，接收優惠、儲值和更多更新',
    'oro.push.subscribe': '訂閱',
    'oro.fd.title': '你的首存獎金即將過期',
    'oro.fd.remain': '剩餘時間',
    'oro.fd.go': '去儲值',
    'oro.deposit.guest': '你正在訪客模式。請立即綁定帳號，以免換機或刪除應用後遺失餘額和進度。',
    'oro.deposit.completeProfile': '完善資料',
    'oro.deposit.tab': '儲值',
    'oro.deposit.withdrawTab': '提現',
    'oro.deposit.channel': '儲值通道',
    'oro.deposit.firstReward': '首存獎勵',
    'oro.deposit.cash': '現金',
    'oro.deposit.reward': '獎勵',
    'oro.deposit.points': '積分',
    'oro.deposit.total': '合計',
    'oro.deposit.optOut': '不參加此優惠',
    'oro.deposit.cta': '儲值 {amount} MXN',
    'oro.deposit.infoTitle': '儲值前請查看可參加的優惠。',
    'oro.deposit.infoDesc': '如有疑問請聯絡客服。',
    'oro.deposit.how': '如何儲值',
    'oro.deposit.noAccount': '未偵測到帳戶',
    'oro.deposit.addWithdraw': '新增提現帳戶',
    'oro.deposit.balance': '餘額',
    'oro.deposit.withdrawable': '可提現餘額',
    'oro.deposit.withdrawAmount': '提現金額',
    'oro.deposit.withdrawPh': '輸入提現金額',
    'oro.deposit.safe': '由官方 Orocasino 與可信第三方提供安全存取。',
    'oro.deposit.safeContact': '如有疑問，請聯絡我們的',
    'oro.deposit.liveSupport': '線上客服',
    'oro.deposit.tip.0': '完成儲值後即可參加活動贏獎勵。馬上行動！',
    'oro.deposit.tip.1': '請確保儲值金額與付款一致，差額可能導致延遲或失敗。',
    'oro.deposit.tip.2': '最低儲值和提現金額為 50.00 MXN。詳情見條款。',
    'oro.wallet.title': '銀行卡管理',
    'oro.wallet.addAccount': '新增帳戶',
    'oro.wallet.addBank': '新增銀行卡',
    'oro.wallet.addUsdt': '新增 USDT 錢包地址',
    'oro.wallet.addPix': '新增 PIX',
    'oro.wallet.addEwallet': '新增電子錢包',
    'oro.wallet.accountName': '帳戶名',
    'oro.wallet.bankName': '銀行名稱',
    'oro.wallet.bankAccount': '銀行帳號',
    'oro.wallet.walletName': '錢包名稱',
    'oro.wallet.currency': '幣種',
    'oro.wallet.chain': '鏈',
    'oro.wallet.walletAddr': '錢包地址',
    'oro.wallet.notes': '備註',
    'oro.wallet.noteExchange': '請新增你自己的交易所錢包。',
    'oro.wallet.usdtOnly': '僅支援 USDT {chain} 地址。',
    'oro.wallet.usdtPh': '輸入 USDT {chain} 地址',
    'oro.wallet.holder': '持有人姓名',
    'oro.wallet.pixType': '金鑰類型',
    'oro.wallet.pixKey': '金鑰',
    'oro.wallet.ewalletNo': '錢包號碼',
    'oro.wallet.contactSupport': '請聯絡客服',
    'oro.wallet.ph.account': '請輸入帳戶名',
    'oro.wallet.ph.bank': '請輸入銀行名稱',
    'oro.wallet.ph.bankAcc': '請輸入銀行帳號',
    'oro.wallet.ph.wallet': '請輸入錢包名稱',
    'oro.wallet.ph.holder': '請輸入持有人姓名',
    'oro.wallet.ph.ewallet': '請輸入錢包號碼',
    'oro.wallet.err.account': '請輸入帳戶名',
    'oro.wallet.err.bank': '請輸入銀行名稱',
    'oro.wallet.err.bankAcc': '請輸入銀行帳號',
    'oro.wallet.err.holder': '請輸入持有人姓名',
    'oro.wallet.err.ewallet': '請輸入錢包號碼',
    'oro.wallet.err.addr': '請輸入收款地址',
    'oro.wallet.err.trcStart': 'TRC-20 地址必須以 T 開頭',
    'oro.wallet.err.trcLen': 'TRC-20 地址必須為 34 位',
    'oro.wallet.err.addrStart': '{chain} 地址必須以 {prefix} 開頭',
    'oro.wallet.err.addrLen': '{chain} 地址必須為 {n} 位',
    'oro.wallet.err.walletName': '請輸入錢包名稱',
    'oro.wallet.err.chain': '請選擇鏈',
    'oro.wallet.err.pixKey': '請輸入金鑰',
    'oro.wallet.err.required': '請填寫{field}',
    'oro.wallet.err.digits': '{field}須為{n}位數字',
    'oro.wallet.err.invalid': '{field}格式不正確',
    'oro.wallet.err.binMismatch': '{field}與所選銀行不匹配',
    'oro.wallet.binHint': '卡號必須屬於所選銀行',
    'oro.wallet.delete': '刪除',
    'oro.wallet.deleted': '已刪除',
    'oro.wallet.empty': '暫無帳戶',
    'oro.wallet.saved': '已儲存',
    'oro.wallet.tab.bank_card': '銀行卡',
    'oro.wallet.tab.usdt': 'USDT',
    'oro.wallet.tab.e_wallet': '電子錢包',
    'oro.wallet.tab.pix': 'PIX',
    'oro.edit.title': '編輯資料',
    'oro.edit.avatar': '使用者頭像',
    'oro.edit.realName': '真實姓名',
    'oro.edit.realNamePh': '請輸入真實姓名',
    'oro.edit.loginName': '登入帳號',
    'oro.edit.loginNamePh': '請輸入登入帳號',
    'oro.edit.loginReadonly': '正式帳號不可修改。',
    'oro.edit.password': '登入密碼',
    'oro.edit.passwordPh': '6-16 位密碼',
    'oro.edit.hint': '請避免特殊字元，否則帳戶可能不相容。',
    'oro.edit.birthday': '出生日期',
    'oro.edit.datePh': '日 / 月 / 年',
    'oro.edit.phone': '手機號',
    'oro.edit.codePh': '請輸入驗證碼',
    'oro.edit.email': '電子信箱',
    'oro.edit.errAccount': '帳號需為 3-64 位字母、數字或 . _ @ -',
    'oro.edit.errPassword': '密碼需為 6-16 位。',
    'oro.edit.errRealName': '真實姓名需為 2-96 個字元。',
    'oro.edit.errPhone': '請輸入 10 位墨西哥手機號。',
    'oro.edit.errEmail': '請輸入有效信箱。',
    'oro.edit.errBirthday': '需年滿 18 歲。',
    'oro.edit.errTaken': '該登入帳號已被占用。',
    'oro.edit.errPhoneTaken': '該手機號已被占用。',
    'oro.edit.errEmailTaken': '該信箱已被占用。',
    'oro.sec.title': '安全設定',
    'oro.sec.low': '低',
    'oro.sec.pwdTitle': '設定登入密碼。',
    'oro.sec.pwdDesc': '請定期更改密碼以保持安全。',
    'oro.sec.mailTitle': '信箱驗證',
    'oro.sec.mailDesc': '驗證信箱以提高帳戶安全。',
    'oro.sec.sessions': '工作階段',
    'oro.sec.device': '裝置',
    'oro.sec.action': '操作',
    'oro.rec.tx': '交易',
    'oro.rec.bets': '投注紀錄',
    'oro.rec.moves': '資金變動',
    'oro.rec.biz.ACTIVITY_REWARD': '活動獎勵',
    'oro.rec.biz.DEPOSIT': '儲值',
    'oro.rec.biz.DEPOSIT_REBATE': '儲值返利',
    'oro.rec.biz.GAME_REBATE': '遊戲返水',
    'oro.rec.biz.GAME_SPIN': '投注',
    'oro.rec.biz.GIFT_BONUS': '贈送獎勵',
    'oro.rec.biz.MANUAL_CREDIT': '人工加款',
    'oro.rec.biz.MANUAL_DEBIT': '人工扣款',
    'oro.rec.biz.REDEEM_CODE': '兌換碼獎勵',
    'oro.rec.biz.REFERRAL_BONUS': '邀請獎勵',
    'oro.rec.biz.TASK_REWARD': '任務獎勵',
    'oro.rec.biz.VIP_BONUS': 'VIP獎勵',
    'oro.rec.biz.WHEEL_BONUS': '轉盤獎勵',
    'oro.rec.biz.WITHDRAW': '提現',
    'oro.rec.biz.WITHDRAW_HOLD': '提現凍結',
    'oro.rec.biz.WITHDRAW_REFUND': '提現退回',
    'oro.rec.biz.WITHDRAW_UNHOLD': '提現解凍',
    'oro.rec.biz.WUFU_BONUS': '五福獎勵',
    'oro.filter.today': '今天',
    'oro.filter.three_days': '近 3 天',
    'oro.filter.seven_days': '近 7 天',
    'oro.filter.half_month': '近 15 天',
    'oro.filter.one_month': '近 30 天',
    'oro.filter.yesterday': '昨天',
    'oro.filter.month': '本月',
    'oro.filter.deposit': '儲值',
    'oro.filter.withdraw': '提現',
    'oro.filter.all': '全部',
    'oro.filter.allLevels': '全部',
    'oro.filter.level.1': '1 級',
    'oro.filter.level.2': '2 級',
    'oro.filter.level.3': '3 級',
    'oro.notice.title': '通知',
    'oro.notice.empty': '暫無訊息',
    'oro.notice.platform': '平台',
    'oro.notice.personal': '個人',
    'oro.reward.title': '獎勵詳情',
    'oro.reward.conditions': '獎勵條件',
    'oro.reward.tx': '交易',
    'oro.reward.allBonus': '全部獎金',
    'oro.reward.type': '獎勵類型',
    'oro.reward.amount': '獎勵金額',
    'oro.reward.time': '時間',
    'oro.reward.footnote': '顯示最近 90 天資料',
    'oro.reward.claim.0': '贈送彩金',
    'oro.reward.claim.1': '等級彩金',
    'oro.reward.claim.2': '活動優惠',
    'oro.reward.claim.3': '任務獎勵',
    'oro.reward.claim.4': '免費轉盤',
    'oro.reward.claim.5': '五福',
    'oro.reward.claim.6': '推廣獎勵',
    'oro.reward.claim.7': '領取碼',
    'oro.reward.claim.8': '儲值返利',
    'oro.reward.claim.9': '遊戲返水',
    'oro.disc.claimed': '已領獎金',
    'oro.disc.redeem': '兌換碼',
    'oro.disc.empty': '暫無資料',
    'oro.disc.ph': '請輸入兌換碼',
    'oro.disc.fail': '兌換失敗',
    'oro.disc.ok': '兌換成功，已入帳 {amount}',
    'oro.disc.claimOk': '領取成功，已入帳 {amount}',
    'oro.disc.claimFail': '領取失敗',
    'oro.disc.err.REDEEM_ALREADY_CLAIMED': '該碼已被兌換',
    'oro.disc.err.REDEEM_CODE_EXHAUSTED': '該碼已用完',
    'oro.disc.err.REDEEM_CODE_EXPIRED': '該碼已過期',
    'oro.disc.err.REDEEM_CODE_INVALID': '無效兌換碼',
    'oro.disc.err.REDEEM_IP_LIMITED': '嘗試過多，請稍後再試',
    'oro.disc.tab.permanent': '我的獎金',
    'oro.disc.tab.permanent-alt': '常駐獎金',
    'oro.disc.tab.vip': 'VIP 獎金',
    'oro.disc.tab.prizes': '我的獎品',
    'oro.disc.vip.level': '目前 VIP 等級',
    'oro.disc.vip.weekLoss': '本週淨虧損',
    'oro.disc.vip.monthBet': '本月投注',
    'oro.disc.vip.todayLoss': '昨日淨虧損',
    'oro.disc.vip.yesterdayBet': '昨日投注',
    'oro.disc.vip.reward': '獎勵',
    'oro.disc.vip.nextReward': '下檔獎勵',
    'oro.disc.vip.granted': '已入帳',
    'oro.disc.vip.autoHint': '滿足條件後自動發放。',
    'oro.disc.vip.manualHint': '滿足條件後需手動領取。',
    'oro.disc.standing.scratch': '刮刮卡',
    'oro.disc.standing.wheel': '轉盤',
    'oro.disc.standing.jackpot': '字母獎池',
    'oro.disc.standing.rescue': '日救援金',
    'oro.disc.standing.times': '可用次數',
    'oro.jackpot.title': '字母獎池',
    'oro.jackpot.todayReward': '今日可領',
    'oro.jackpot.withdrawable': '可提現',
    'oro.jackpot.spinsLeft': '剩餘次數',
    'oro.jackpot.bonus': '積分',
    'oro.jackpot.taskBetBtn': '投注',
    'oro.jackpot.taskDepositBtn': '儲值',
    'oro.jackpot.pending': '次日待領 {amount}',
    'oro.jackpot.claim': '領取',
    'oro.jackpot.claimOk': '已領取 {amount}',
    'oro.jackpot.draw': '抽獎',
    'oro.jackpot.chances': '剩餘次數：{n}',
    'oro.jackpot.confirmDraw': '消耗 {amount} 積分抽一次？',
    'oro.jackpot.insufficient': '積分不足',
    'oro.jackpot.noChances': '今日次數已用完',
    'oro.jackpot.unavailable': '獎池暫不可用',
    'oro.jackpot.complete': '集齊一檔獎金！',
    'oro.jackpot.tasks': '獲取次數',
    'oro.jackpot.spinOne': '次',
    'oro.jackpot.spinMany': '次',
    'oro.jackpot.task.login': 'VIP 每日登入 · {n} {unit}',
    'oro.jackpot.task.bet': '老虎機投注 {amount} · {n} {unit}',
    'oro.jackpot.task.deposit': '儲值 {amount} · {n} {unit}',
    'oro.jackpot.taskGo': '去完成',
    'oro.jackpot.taskDone': '已完成',
    'oro.jackpot.rulesTitle': '玩法說明',
    'oro.jackpot.rulesCost': '每次抽獎消耗 1 次機會和 20 積分。積分不可提現。',
    'oro.jackpot.rulesCollect': '集齊 MINI / MINOR / MAJOR / GRAND 字母，隨機獲得該檔現金。',
    'oro.jackpot.rulesReset': '每天 00:00 重置已獲得的字母和抽獎次數。',
    'oro.jackpot.rulesClaim': '集齊當天可領現金。每檔每天最多齊 1 次。活動停用後仍可領取已入帳金額。',
    'oro.jackpot.rulesPoints': '每日次數按 VIP。投注和儲值任務按站點時區統計。',
    'oro.scratch.title': '刮刮卡',
    'oro.scratch.introBefore': '集齊',
    'oro.scratch.introAfter': '張相同卡即可兌獎。',
    'oro.scratch.cards': '我的卡券',
    'oro.scratch.chances': '{n} 張刮刮卡',
    'oro.scratch.getAttempts': '獲取次數',
    'oro.scratch.thanks': '謝謝惠顧',
    'oro.scratch.noTickets': '完成任務可獲得更多刮刮卡。',
    'oro.scratch.unavailable': '刮刮卡暫不可用。',
    'oro.scratch.redeem': '兌換',
    'oro.scratch.redeemWild': '兌換萬能卡',
    'oro.scratch.taskTitle': '每日任務',
    'oro.scratch.currentTickets': '目前次數：{n}',
    'oro.scratch.cantidad': '數量 {n}',
    'oro.scratch.goComplete': '去完成',
    'oro.scratch.noData': '暫無任務',
    'oro.scratch.congrats': '恭喜',
    'oro.scratch.confirm': '確認',
    'oro.scratch.rulesH2': '規則',
    'oro.scratch.rulesH3': '刮刮卡',
    'oro.scratch.rulesPlay': '玩法',
    'oro.scratch.rulesCover': '刮開封面即可亮出一張卡。',
    'oro.scratch.rulesCollect': '集齊一套即可兌換現金獎。',
    'oro.scratch.rulesWithdraw': '現金獎按配置的打碼倍數計算。',
    'oro.scratch.rulesFair': '每次刮獎在服務端開獎，刮開不會改結果。',
    'oro.scratch.rulesJackpot': '大獎',
    'oro.scratch.rulesRestrict': '同一人、IP 或裝置僅限一個帳戶。',
    'oro.scratch.rulesUse': '僅統計本活動允許的遊戲。',
    'oro.scratch.rulesTags': '老虎機',
    'oro.scratch.rulesOther': '平台可核驗並取消作弊資格。',
    'oro.scratch.rulesAbuse': '禁止濫用、多開和對沖投注。',
    'oro.scratch.rulesFinal': '最終解釋權歸 Orocasino。',
    'oro.scratch.rulesLuck': '請理性遊戲。未滿 18 歲禁止。',
    'oro.disc.available.claim': '領取獎勵',
    'oro.disc.available.goScratch': '去刮獎',
    'oro.disc.available.goWheel': '去轉盤',
    'oro.disc.available.goUse': '去使用',
    'oro.disc.available.coupon': '存款優惠',
    'oro.disc.available.qty': '數量',
    'oro.disc.available.reward': '獎勵',
    'oro.disc.available.percent': '優惠',
    'oro.disc.available.cash': '獎金',
    'oro.tut.step1': '第 1 步',
    'oro.tut.step2': '第 2 步',
    'oro.tut.step3': '第 3 步',
    'oro.tut.step1.title': '1. 在 Safari 中開啟網站。',
    'oro.tut.step2.title': '2. 在 Safari 中開啟網站。',
    'oro.tut.step3.title': '3. 加入主畫面。',
    'oro.tut.step1.desc': '在手機上開啟 Safari。',
    'oro.tut.step2.desc': '在手機上開啟 Safari。',
    'oro.tut.step3.desc': '點一下「加入主畫面」。',
    'oro.game.unavailable': '暫時無法進入遊戲，請稍後再試。',
    'oro.game.notFound': '該遊戲不存在或已下架。',
    'oro.game.balanceTooLow': '可用餘額不足 1，請先儲值再進入遊戲。',
    'oro.game.home': '返回首頁',
    'oro.promo.details': '詳情',
    'oro.promo.loading': '載入中…',
    'oro.promo.loadError': '載入失敗',
    'oro.promo.retry': '重試',
    'oro.promo.claiming': '領取中…',
    'oro.promo.claim': '領取 {amount}',
    'oro.promo.claimed': '已領取',
    'oro.promo.locked': '暫未解鎖',
    'oro.promo.login': '登入後領取',
    'oro.promo.autoGrantHint': '系統自動入帳。',
    'oro.promo.empty': '暫無活動',
    'oro.promo.cta': '立即參與',
    'oro.promo.app.title': '下載 APP 最高可得',
    'oro.promo.vip.title': '升級 VIP',
    'oro.promo.cashback.title': '每週 VIP 返水',
    'oro.promo.monthly.title': '每月 VIP 收益',
    'oro.promo.daily.title': '每日虧損 1%',
    'oro.promo.rescue.title': '救援金',
    'oro.promo.rescue.yesterdayLoss': '昨日虧損',
    'oro.promo.rescue.claimCost': '領取需要消耗對應金額的積分',
    'oro.promo.rescue.needMin': '未達最低檔，需滿 {amount} 才可領取',
    'oro.promo.rescue.needMinPlain': '未達最低檔，暫不可領取',
    'oro.promo.rescue.canClaim': '可領 {amount}',
    'oro.promo.rescue.claimedHint': '今日已領取',
    'oro.promo.rescue.loginHint': '登入後查看昨日虧損',
    'oro.promo.inviteChest.title': '寶箱獎勵',
    'oro.promo.inviteChest.valid': '有效邀請',
    'oro.promo.inviteChest.next': '下一檔：{n}',
    'oro.promo.inviteChest.complete': '寶箱已全部領取',
    'oro.promo.inviteChest.ready': '{n} 個寶箱可領取',
    'oro.promo.inviteChest.tapClaim': '領取',
    'oro.promo.inviteChest.claimed': '已領取',
    'oro.sign.hero': '新人 7 日簽到任務',
    'oro.sign.sub': '每日獎勵',
    'oro.sign.tab.seven': '新人 7 日任務',
    'oro.sign.tab.daily': '任務',
    'oro.sign.section.seven': '新人 7 日簽到任務',
    'oro.sign.section.daily': '每日任務',
    'oro.sign.day': '第 {n} 天',
    'oro.sign.done': '已完成',
    'oro.sign.pending': '待領取',
    'oro.sign.notStarted': '活動未開始',
    'oro.sign.expired': '已過期',
    'oro.sign.chest.unlockHint': '註冊滿 8 天解鎖 Bonus 寶箱。',
    'oro.sign.chest.progress': '再賺 {need} 即可獲得 {reward}',
    'oro.sign.chest.progressMax': '已達最高獎勵',
    'oro.sign.chest.accessRewards': '簽到獎勵',
    'oro.sign.chest.open': '開啟',
    'oro.sign.chest.open10': '開 10 個',
    'oro.sign.chest.checkIn': '簽到',
    'oro.sign.chest.checkInWait': '簽到（{n}s）',
    'oro.sign.chest.signedToday': '今天已簽到',
    'oro.sign.chest.signOk': '簽到成功',
    'oro.sign.chest.unavailable': '暫不可用',
    'oro.sign.chest.claimed': '已領取',
    'oro.sign.chest.rewardTitle': '恭喜',
    'oro.sign.chest.claim': '領取',
    'oro.sign.chest.goDeposit': '去儲值',
    'oro.sign.chest.goInvite': '去邀請',
    'oro.sign.chest.goBet': '去投注',
    'oro.sign.chest.resignTitle': '補簽',
    'oro.sign.chest.resignBody': '使用 {price} 積分補簽第 {n} 天？',
    'oro.sign.chest.bonusLabel': '積分：{amount}',
    'oro.sign.chest.openedTitle': '寶箱已開啟！',
    'oro.sign.chest.openedTotal': '合計：+{amount}',
    'oro.sign.chest.accept': '確定',
    'oro.sign.chest.insufficient': '積分不足',
    'oro.sign.chest.toastBonus': '+{amount}',
    'oro.sign.chest.toastResign': '+ 第 {n} 天寶箱',
    'oro.sign.chest.task.bet_first': '投注 ${n}',
    'oro.sign.chest.task.bet_first_vip': '投注 ${n}',
    'oro.sign.chest.task.deposit_first': '儲值 ${n}',
    'oro.sign.chest.task.invite_deposit': '邀請好友首儲',
    'oro.sign.tab.chest': 'Bonus 寶箱',
    'oro.sign.invite.cta': '去邀請',
    'oro.sign.invite.summary': '已邀請 {n} 人，可領 {amount}',
    'oro.sign.reward.coupon': '優惠券 +{p}%',
    'oro.sign.reward.scratch': '刮刮卡',
    'oro.sign.reward.wheel': '轉盤次數',
    'oro.sign.claimSuccess': '領取成功',
    'oro.sign.rewardIssued': '獎勵已發放',
    'oro.sign.rewardReceived': '獎勵已到帳',
    'oro.sign.claim': '領取獎勵',
    'oro.sign.goBet': '去投注',
    'oro.sign.invite': '邀請好友',
    'oro.sign.validBet': '有效投注',
    'oro.sign.d1.name': '第 1 天 - 登入簽到',
    'oro.sign.d2.name': '第 2 天 - 登入簽到',
    'oro.sign.d3.name': '第 3 天 - 投注 10 簽到',
    'oro.sign.d4.name': '第 4 天 - 投注 20 簽到',
    'oro.sign.d5.name': '第 5 天 - 投注 30 簽到',
    'oro.sign.d6.name': '第 6 天 - 投注 50 簽到',
    'oro.sign.d7.name': '第 7 天 - 投注 100 簽到',
    'oro.sign.invite.name': '邀請 1 位有效使用者',
    'oro.sign.bet100.name': '老虎機投注 100',
    'oro.sign.bet1000.name': '老虎機投注 1000',
    'oro.sign.bet5000.name': '老虎機投注 5000',
    'oro.vip.benefits': 'VIP 等級與權益',
    'oro.vip.about': '關於 Orocasino',
    'oro.vip.tab.upgrade': 'VIP 升級獎金',
    'oro.vip.tab.daily': '每日返水',
    'oro.vip.tab.monthly': '每月固定獎金',
    'oro.vip.tab.weekly': '每週返水',
    'oro.vip.tab.jackpot': '獎池抽獎',
    'oro.vip.col.vip': 'VIP',
    'oro.vip.col.levelBonus': '等級獎金',
    'oro.vip.col.jackpotSpins': '每日次數',
    'oro.vip.col.rebatePct': '返水比例',
    'oro.vip.col.maxPrize': '最高獎金',
    'oro.vip.col.validBets': '有效投注',
    'oro.vip.col.fixedBonus': '固定獎金',
    'oro.vip.reward.recompensas.title': '獎勵',
    'oro.vip.reward.diario.title': '每日獎金',
    'oro.vip.reward.ayuda.title': '救援',
    'oro.vip.reward.mensual.title': '每月獎金',
    'oro.vip.reward.semanal.title': '每週獎金',
    'oro.vip.reward.soporte.title': 'VIP 客服',
    'oro.vip.reward.cumple.title': '生日',
    'oro.vip.reward.exclusivos.title': '專屬',
    'oro.vip.reward.fisicos.title': '實體禮品',
    'oro.vip.reward.fisicos.lock': '已解鎖',
    'oro.vip.reward.jackpot.title': '獎池抽獎',
    'oro.vip.reward.jackpot.desc': '每日登入依 VIP 等級獲贈獎池抽獎次數，等級越高次數越多。',
    'oro.vip.reward.recompensas.desc': '每升一級 VIP 即可領取對應獎勵，等級越高獎勵越大。',
    'oro.vip.reward.diario.desc': '會員可按每日投注額領取額外獎金，投注越多獎勵越高。',
    'oro.vip.reward.ayuda.desc': '短期波動時可領取專屬 VIP 救援金，保持穩定體驗。',
    'oro.vip.reward.mensual.desc': '按會員等級與月活躍度發放月獎金。',
    'oro.vip.reward.semanal.desc': '保持活躍即可領取週獎金。',
    'oro.vip.reward.soporte.desc': '高級會員享專屬 VIP 管家：快速回應、優先處理和個人化協助。',
    'oro.vip.reward.cumple.desc': '生日當月送上祝福與專屬禮物。',
    'oro.vip.reward.exclusivos.desc': 'VIP 可參加專屬活動、限時折扣與平台特權。',
    'oro.vip.reward.fisicos.desc': '達到指定 VIP 等級可獲實體禮品。',
    'oro.vip.faq.0.q': '什麼是 Orocasino VIP 俱樂部？',
    'oro.vip.faq.0.a': '成為 VIP，享受超預期的專屬體驗。',
    'oro.vip.faq.1.q': '加入 VIP 俱樂部有哪些權益？',
    'oro.vip.faq.1.a': 'VIP 俱樂部可解鎖一手資訊、獎金、更高返水、專屬活動與專屬經理。',
    'oro.vip.faq.2.q': '想加入 VIP 但還沒達標，該怎麼辦？',
    'oro.vip.faq.2.a': '保持每日活躍、遊玩、邀請好友並經常儲值。',
    'oro.vip.faq.3.q': '我已是會員卻還沒收到獎金，為什麼？',
    'oro.vip.faq.3.a': '週獎金每 7 天發放，月獎金每 30 天發放（需達標）。',
    'oro.vip.faq.4.q': '如何成為 VIP 俱樂部成員？',
    'oro.vip.faq.4.a': '儲值和投注達到標準後即成為對應 VIP。',
    'oro.vip.faq.5.q': '什麼會影響週/月獎金？',
    'oro.vip.faq.5.a': '收益主要取決於遊戲活躍度；生日獎金除外。',
    'oro.vip.faq.6.q': 'VIP 俱樂部成員有特別優惠嗎？',
    'oro.vip.faq.6.a': '有，你的專屬經理會詳細說明。',
    'oro.team.title': '團隊中心',
    'oro.team.info': '團隊資訊',
    'oro.team.validFriends': '有效好友總數',
    'oro.team.todayBets': '今日總投注',
    'oro.team.forecast': '按今日即時資料，下一評級預計為：{status}',
    'oro.team.rankTip': '團隊等級每天午夜按昨日資料更新；進度按今日即時資料。',
    'oro.team.rewardLv0': '0 級獎勵',
    'oro.team.rewardLv': '{level} 級獎勵',
    'oro.team.nivel': '{level} 級',
    'oro.team.rewardText': '儲值最高返 5%',
    'oro.team.refLink': '推薦連結',
    'oro.team.invite': '邀請好友',
    'oro.team.distributed': '已發放獎金',
    'oro.team.sentTotal': '累計已發放',
    'oro.team.commission': '佣金',
    'oro.team.faq': '常見問題',
    'oro.team.paidToday': '今日已付獎金 MXN0.00',
    'oro.team.refDeposit': '推薦儲值獎金',
    'oro.team.delay': '獎勵可能延遲到帳',
    'oro.team.claimNow': '立即領取',
    'oro.team.rebateLog': '返利獎勵紀錄',
    'oro.team.refBonus': '推薦獎金',
    'oro.team.inviteLead': '邀請好友一起參與。',
    'oro.team.friendGot': '好友已獲得',
    'oro.team.inviteProgress': '今日邀請進度：0/999',
    'oro.team.depositBonus': '儲值金額 / 獎金',
    'oro.team.depositAmt': '儲值金額',
    'oro.team.anyDeposit': '任意儲值',
    'oro.team.friendDepositPercentDesc': '好友任意金額儲值，均按同一比例贈送。',
    'oro.team.bonus': '獎金',
    'oro.team.howPromo': '如何獲得推廣獎金？',
    'oro.team.whatPlan': '什麼是團隊分紅計畫？',
    'oro.team.howEarn': '如何賺取推廣獎金？',
    'oro.team.lv': '團隊等級',
    'oro.team.members': '團隊成員',
    'oro.team.volume': '團隊流水（投注）',
    'oro.team.notes': '備註 / 規則：',
    'oro.team.calc': '佣金計算器',
    'oro.team.calcRate': '佣金比例：10%',
    'oro.team.calcLabel': '輸入有效流水',
    'oro.team.calcPh': '佣金比例 (%)',
    'oro.team.settleTitle': '佣金結算與提現',
    'oro.team.settleAmt': '累計已結算佣金',
    'oro.team.settle1': '結算：每日 00:00（UTC+8）',
    'oro.team.settle2': '提現：24 小時內到卡/錢包',
    'oro.team.settle3': '最低提現：0.00',
    'oro.team.settle4': '要求：身分驗證',
    'oro.team.refSub': '邀請好友加入即可獲得獎金。',
    'oro.team.copied': '連結已複製',
    'oro.team.tab.dashboard': '控制台',
    'oro.team.tab.bonus': '我的獎金',
    'oro.team.tab.referral': '推薦獎金',
    'oro.team.tab.rules': '規則',
    'oro.team.stat.invite': '邀請好友',
    'oro.team.stat.valid': '有效好友',
    'oro.team.stat.today-invite': '今日邀請',
    'oro.team.stat.today-valid': '今日有效',
    'oro.team.stat.today-deposit': '今日儲值',
    'oro.team.stat.today-volume': '今日流水',
    'oro.team.bonus.register': '今日推薦註冊獎金',
    'oro.team.bonus.cashback': '投注返水',
    'oro.team.bonus.bet-bonus': '投注返利獎金',
    'oro.team.step.1.title': '分享給好友',
    'oro.team.step.1.desc': '把推薦連結、推薦碼或 QR 碼分享給好友。',
    'oro.team.step.2.title': '好友註冊並儲值',
    'oro.team.step.2.desc': '邀請好友註冊並完成首儲。',
    'oro.team.step.3.title': '最高可賺 $99,999',
    'oro.team.step.3.desc': '好友投注和儲值後，你可獲得佣金。',
    'oro.team.faq.0.q': 'Orocasino 代理計畫是什麼？',
    'oro.team.faq.0.a': '邀請好友註冊遊戲即可賺取佣金和獎勵。',
    'oro.team.faq.1.q': '參與需要費用嗎？',
    'oro.team.faq.1.a': '代理計畫完全免費。',
    'oro.team.faq.2.q': '我賺了多少？',
    'oro.team.faq.2.a': '可在控制台和「我的獎金」查看累計收益。',
    'oro.team.faq.3.q': '好友越多收益越好嗎？',
    'oro.team.faq.3.a': '有效好友越多，獎勵等級越高。',
    'oro.share.title': '分享',
    'oro.share.player': '玩家 {name}',
    'oro.share.inviteCode': '邀請碼 {code}',
    'oro.share.save': '儲存圖片',
    'oro.share.link': '推薦連結：',
    'oro.share.codeLabel': '邀請碼：',
    'oro.share.copied': '複製成功',
    'oro.share.copyFail': '複製失敗',
    'oro.share.saved': '儲存成功',
    'oro.share.saveFail': '儲存失敗',
    'oro.share.history': '歷史',
    'oro.share.received': '已收',
    'oro.share.sent': '已發放',
    'oro.share.depositFriends': '儲值好友',
    'oro.share.recentInvite': '近期邀請好友',
    'oro.share.recentDeposit': '近期儲值好友',
    'oro.hist.type.received': '返利獎勵紀錄',
    'oro.hist.type.retired': '團隊返利紀錄',
    'oro.lottery.silver': '每日轉盤',
    'oro.lottery.gold': '每日轉盤',
    'oro.lottery.diamond': 'MX 每日轉盤',
    'oro.lottery.unlock': '{vip} 解鎖',
    'oro.lottery.times': '次',
    'oro.lottery.thanks': '謝謝',
    'oro.lottery.recent': '近期轉盤大獎',
    'oro.lottery.pending': '待解鎖',
    'oro.lottery.needVip': '需要 VIP {level} 或以上',
    'oro.lottery.upgrade': '提升 VIP ➔',
    'oro.lottery.rulesBody': '轉動轉盤贏獎。更高等級轉盤需 VIP 解鎖。',
    'oro.lottery.noTickets': '抽獎次數不足',
    'oro.lottery.unavailable': '轉盤暫不可用。',
    'oro.lottery.congrats': '恭喜獲得',
    'oro.team.inviteEarn': '邀請好友贏獎勵。',
    'oro.team.historyLink': '歷史 >',
    'oro.team.friendDepositDesc': '好友儲值後，你將按金額獲得獎金。',
    'oro.team.refDepositNote': '下級再次儲值時，按團隊等級發放對應獎勵。',
    'oro.team.stepNote': '備註：代理收益無上限，付出越多回報越大。',
    'oro.team.planBody': '作為代理招募下級組成團隊，團隊業績越高分紅越高。',
    'oro.team.levelNote': '返利和儲值獎金按當日團隊等級變化。團隊成員為當前有效使用者。團隊投注為下級當日總流水。',
    'oro.team.calcRun': '計算',
    'oro.team.calcResult': '預估獎勵',
    'oro.edit.getCode': '取得驗證碼',
  },
};
